var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "course-icon",
      attrs: { "data-size": _vm.size, "data-value": this.value },
    },
    [
      _vm.existingIllustrations.includes(this.value)
        ? _c(
            "svg",
            {
              attrs: {
                width: "43",
                height: "26",
                viewBox: "0 0 43 26",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              this.value === "us" || this.value === "en"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M40.7324 2H18V4H41V3C41 2.63571 40.9026 2.29417 40.7324 2Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M18 8H41V6H18V8Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M18 12H41V10H18V12Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 16H41V14H1V16Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 20H41V18H1V20Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M1.26756 24C1.09739 23.7058 1 23.3643 1 23V22H41V23C41 23.3643 40.9026 23.7058 40.7324 24H1.26756Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 14H18.0001V1H3C1.89543 1 1 1.89543 1 3V14Z",
                        fill: "#3C3B6E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 9.92925H16.93L16.75 9.375L16.5783 9.92925H16L16.4635 10.2862L16.273 10.875L16.7523 10.5067L17.2218 10.869L17.0335 10.2862L17.5 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 11.2418H15.4803L15.3003 10.6875L15.1285 11.2418H14.5503L15.0138 11.5987L14.8233 12.1875L15.3025 11.8192L15.772 12.1815L15.5838 11.5987L16.0503 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 8.61675H15.4803L15.3003 8.0625L15.1285 8.61675H14.5503L15.0138 8.97375L14.8233 9.5625L15.3025 9.19425L15.772 9.5565L15.5838 8.97375L16.0503 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 5.99175H15.4803L15.3003 5.4375L15.1285 5.99175H14.5503L15.0138 6.34875L14.8233 6.9375L15.3025 6.56925L15.772 6.9315L15.5838 6.34875L16.0503 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 3.36675H15.4803L15.3003 2.8125L15.1285 3.36675H14.5503L15.0138 3.72375L14.8233 4.3125L15.3025 3.94425L15.772 4.3065L15.5838 3.72375L16.0503 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 11.2418H12.5799L12.3999 10.6875L12.2282 11.2418H11.6499L12.1134 11.5987L11.9229 12.1875L12.4022 11.8192L12.8717 12.1815L12.6834 11.5987L13.1499 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 8.61675H12.5799L12.3999 8.0625L12.2282 8.61675H11.6499L12.1134 8.97375L11.9229 9.5625L12.4022 9.19425L12.8717 9.5565L12.6834 8.97375L13.1499 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 5.99175H12.5799L12.3999 5.4375L12.2282 5.99175H11.6499L12.1134 6.34875L11.9229 6.9375L12.4022 6.56925L12.8717 6.9315L12.6834 6.34875L13.1499 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 3.36675H12.5799L12.3999 2.8125L12.2282 3.36675H11.6499L12.1134 3.72375L11.9229 4.3125L12.4022 3.94425L12.8717 4.3065L12.6834 3.72375L13.1499 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 11.2418H9.68L9.5 10.6875L9.32825 11.2418H8.75L9.2135 11.5987L9.023 12.1875L9.50225 11.8192L9.97175 12.1815L9.7835 11.5987L10.25 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 8.61675H9.68L9.5 8.0625L9.32825 8.61675H8.75L9.2135 8.97375L9.023 9.5625L9.50225 9.19425L9.97175 9.5565L9.7835 8.97375L10.25 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 5.99175H9.68L9.5 5.4375L9.32825 5.99175H8.75L9.2135 6.34875L9.023 6.9375L9.50225 6.56925L9.97175 6.9315L9.7835 6.34875L10.25 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 3.36675H9.68L9.5 2.8125L9.32825 3.36675H8.75L9.2135 3.72375L9.023 4.3125L9.50225 3.94425L9.97175 4.3065L9.7835 3.72375L10.25 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 11.2418H6.7801L6.6001 10.6875L6.42835 11.2418H5.8501L6.3136 11.5987L6.1231 12.1875L6.60235 11.8192L7.07185 12.1815L6.8836 11.5987L7.3501 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 8.61675H6.7801L6.6001 8.0625L6.42835 8.61675H5.8501L6.3136 8.97375L6.1231 9.5625L6.60235 9.19425L7.07185 9.5565L6.8836 8.97375L7.3501 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 5.99175H6.7801L6.6001 5.4375L6.42835 5.99175H5.8501L6.3136 6.34875L6.1231 6.9375L6.60235 6.56925L7.07185 6.9315L6.8836 6.34875L7.3501 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 3.36675H6.7801L6.6001 2.8125L6.42835 3.36675H5.8501L6.3136 3.72375L6.1231 4.3125L6.60235 3.94425L7.07185 4.3065L6.8836 3.72375L7.3501 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 11.2418H3.8802L3.7002 10.6875L3.52845 11.2418H2.9502L3.4137 11.5987L3.2232 12.1875L3.70245 11.8192L4.17195 12.1815L3.9837 11.5987L4.4502 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 8.61675H3.8802L3.7002 8.0625L3.52845 8.61675H2.9502L3.4137 8.97375L3.2232 9.5625L3.70245 9.19425L4.17195 9.5565L3.9837 8.97375L4.4502 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 5.99175H3.8802L3.7002 5.4375L3.52845 5.99175H2.9502L3.4137 6.34875L3.2232 6.9375L3.70245 6.56925L4.17195 6.9315L3.9837 6.34875L4.4502 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 3.36675H3.8802L3.7002 2.8125L3.52845 3.36675H2.9502L3.4137 3.72375L3.2232 4.3125L3.70245 3.94425L4.17195 4.3065L3.9837 3.72375L4.4502 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 12.5543H16.93L16.75 12L16.5783 12.5543H16L16.4635 12.9112L16.273 13.5L16.7523 13.1317L17.2218 13.494L17.0335 12.9112L17.5 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 12.5543H14.0301L13.8501 12L13.6783 12.5543H13.1001L13.5636 12.9112L13.3731 13.5L13.8523 13.1317L14.3218 13.494L14.1336 12.9112L14.6001 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 9.92925H14.0301L13.8501 9.375L13.6783 9.92925H13.1001L13.5636 10.2862L13.3731 10.875L13.8523 10.5067L14.3218 10.869L14.1336 10.2862L14.6001 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 7.30425H14.0301L13.8501 6.75L13.6783 7.30425H13.1001L13.5636 7.66125L13.3731 8.25L13.8523 7.88175L14.3218 8.244L14.1336 7.66125L14.6001 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 4.67925H14.0301L13.8501 4.125L13.6783 4.67925H13.1001L13.5636 5.03625L13.3731 5.625L13.8523 5.25675L14.3218 5.619L14.1336 5.03625L14.6001 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 2.05425H14.0301L13.8501 1.5L13.6783 2.05425H13.1001L13.5636 2.41125L13.3731 3L13.8523 2.63175L14.3218 2.994L14.1336 2.41125L14.6001 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 12.5543H11.1302L10.9502 12L10.7784 12.5543H10.2002L10.6637 12.9112L10.4732 13.5L10.9524 13.1317L11.4219 13.494L11.2337 12.9112L11.7002 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 9.92925H11.1302L10.9502 9.375L10.7784 9.92925H10.2002L10.6637 10.2862L10.4732 10.875L10.9524 10.5067L11.4219 10.869L11.2337 10.2862L11.7002 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 7.30425H11.1302L10.9502 6.75L10.7784 7.30425H10.2002L10.6637 7.66125L10.4732 8.25L10.9524 7.88175L11.4219 8.244L11.2337 7.66125L11.7002 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 4.67925H11.1302L10.9502 4.125L10.7784 4.67925H10.2002L10.6637 5.03625L10.4732 5.625L10.9524 5.25675L11.4219 5.619L11.2337 5.03625L11.7002 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 2.05425H11.1302L10.9502 1.5L10.7784 2.05425H10.2002L10.6637 2.41125L10.4732 3L10.9524 2.63175L11.4219 2.994L11.2337 2.41125L11.7002 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 12.5543H8.23029L8.05029 12L7.87854 12.5543H7.30029L7.76379 12.9112L7.57329 13.5L8.05254 13.1317L8.52204 13.494L8.33379 12.9112L8.80029 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 9.92925H8.23029L8.05029 9.375L7.87854 9.92925H7.30029L7.76379 10.2862L7.57329 10.875L8.05254 10.5067L8.52204 10.869L8.33379 10.2862L8.80029 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 7.30425H8.23029L8.05029 6.75L7.87854 7.30425H7.30029L7.76379 7.66125L7.57329 8.25L8.05254 7.88175L8.52204 8.244L8.33379 7.66125L8.80029 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 4.67925H8.23029L8.05029 4.125L7.87854 4.67925H7.30029L7.76379 5.03625L7.57329 5.625L8.05254 5.25675L8.52204 5.619L8.33379 5.03625L8.80029 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 2.05425H8.23029L8.05029 1.5L7.87854 2.05425H7.30029L7.76379 2.41125L7.57329 3L8.05254 2.63175L8.52204 2.994L8.33379 2.41125L8.80029 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 12.5543H5.3299L5.1499 12L4.97815 12.5543H4.3999L4.8634 12.9112L4.6729 13.5L5.15215 13.1317L5.62165 13.494L5.4334 12.9112L5.8999 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 9.92925H5.3299L5.1499 9.375L4.97815 9.92925H4.3999L4.8634 10.2862L4.6729 10.875L5.15215 10.5067L5.62165 10.869L5.4334 10.2862L5.8999 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 7.30425H5.3299L5.1499 6.75L4.97815 7.30425H4.3999L4.8634 7.66125L4.6729 8.25L5.15215 7.88175L5.62165 8.244L5.4334 7.66125L5.8999 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 4.67925H5.3299L5.1499 4.125L4.97815 4.67925H4.3999L4.8634 5.03625L4.6729 5.625L5.15215 5.25675L5.62165 5.619L5.4334 5.03625L5.8999 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 2.05425H5.3299L5.1499 1.5L4.97815 2.05425H4.3999L4.8634 2.41125L4.6729 3L5.15215 2.63175L5.62165 2.994L5.4334 2.41125L5.8999 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 12.5543H2.43L2.25 12L2.07825 12.5543H1.5L1.9635 12.9112L1.773 13.5L2.25225 13.1317L2.72175 13.494L2.5335 12.9112L3 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 9.92925H2.43L2.25 9.375L2.07825 9.92925H1.5L1.9635 10.2862L1.773 10.875L2.25225 10.5067L2.72175 10.869L2.5335 10.2862L3 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 7.30425H2.43L2.25 6.75L2.07825 7.30425H1.5L1.9635 7.66125L1.773 8.25L2.25225 7.88175L2.72175 8.244L2.5335 7.66125L3 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 4.67925H2.43L2.25 4.125L2.07825 4.67925H1.5L1.9635 5.03625L1.773 5.625L2.25225 5.25675L2.72175 5.619L2.5335 5.03625L3 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 2.05425H2.43L2.25 1.5L2.07825 2.05425H1.5L1.9635 2.41125L1.773 3L2.25225 2.63175L2.72175 2.994L2.5335 2.41125L3 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 7.30425H16.93L16.75 6.75L16.5783 7.30425H16L16.4635 7.66125L16.273 8.25L16.7523 7.88175L17.2218 8.244L17.0335 7.66125L17.5 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 4.67925H16.93L16.75 4.125L16.5783 4.67925H16L16.4635 5.03625L16.273 5.625L16.7523 5.25675L17.2218 5.619L17.0335 5.03625L17.5 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 2.05425H16.93L16.75 1.5L16.5783 2.05425H16L16.4635 2.41125L16.273 3L16.7523 2.63175L17.2218 2.994L17.0335 2.41125L17.5 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "gb"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H9L1 4V9Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M6 1L17 8V1H6Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17V22L9 17H1Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M6 25H17V18L6 25Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M33.0005 17L41.0005 22V17H33.0005Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M25 25H36L25 18V25Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M33 9H41V4L33 9Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M25 1V8L36 1H25Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M1.02783 2.66425L10.4118 8.99997H12.9998L1.70862 1.47253C1.35604 1.77087 1.10815 2.18908 1.02783 2.66425Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M3.61734 25L16.0003 17H13.2823L1.71631 24.5336C2.06369 24.8247 2.51142 25 3.0001 25H3.61734Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M40.9645 23.3773L31 17H28L40.2661 24.5483C40.6215 24.2573 40.8749 23.8464 40.9645 23.3773Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M38.4331 1L26 9H28.6609L40.2824 1.46522C39.9353 1.17481 39.488 1 39 1H38.4331Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M18 1V10H1V16H18V25H24V16H40.999V10H24V1H18Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "us-gb"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M39 25C40.1046 25 41 24.1046 41 23V2.6C41 1.71634 40.2837 1 39.4001 1H3C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M6 25H17V18L6 25Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M33.0005 17L41.0005 22V17H33.0005Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M25 25H36L25 18V25Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M33 9H41V4L33 9Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M40.9645 23.3773L31 17H28L40.2661 24.5484C40.6215 24.2574 40.875 23.8464 40.9645 23.3773Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 14H18.0001V1H3C1.89543 1 1 1.89543 1 3V14Z",
                        fill: "#3C3B6E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 9.92925H16.93L16.75 9.375L16.5783 9.92925H16L16.4635 10.2862L16.273 10.875L16.7523 10.5067L17.2218 10.869L17.0335 10.2862L17.5 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 11.2418H15.4803L15.3003 10.6875L15.1285 11.2418H14.5503L15.0138 11.5987L14.8233 12.1875L15.3025 11.8192L15.772 12.1815L15.5838 11.5987L16.0503 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 8.61675H15.4803L15.3003 8.0625L15.1285 8.61675H14.5503L15.0138 8.97375L14.8233 9.5625L15.3025 9.19425L15.772 9.5565L15.5838 8.97375L16.0503 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 5.99175H15.4803L15.3003 5.4375L15.1285 5.99175H14.5503L15.0138 6.34875L14.8233 6.9375L15.3025 6.56925L15.772 6.9315L15.5838 6.34875L16.0503 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 3.36675H15.4803L15.3003 2.8125L15.1285 3.36675H14.5503L15.0138 3.72375L14.8233 4.3125L15.3025 3.94425L15.772 4.3065L15.5838 3.72375L16.0503 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 11.2418H12.5799L12.3999 10.6875L12.2282 11.2418H11.6499L12.1134 11.5987L11.9229 12.1875L12.4022 11.8192L12.8717 12.1815L12.6834 11.5987L13.1499 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 8.61675H12.5799L12.3999 8.0625L12.2282 8.61675H11.6499L12.1134 8.97375L11.9229 9.5625L12.4022 9.19425L12.8717 9.5565L12.6834 8.97375L13.1499 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 5.99175H12.5799L12.3999 5.4375L12.2282 5.99175H11.6499L12.1134 6.34875L11.9229 6.9375L12.4022 6.56925L12.8717 6.9315L12.6834 6.34875L13.1499 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 3.36675H12.5799L12.3999 2.8125L12.2282 3.36675H11.6499L12.1134 3.72375L11.9229 4.3125L12.4022 3.94425L12.8717 4.3065L12.6834 3.72375L13.1499 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 11.2418H9.68L9.5 10.6875L9.32825 11.2418H8.75L9.2135 11.5987L9.023 12.1875L9.50225 11.8192L9.97175 12.1815L9.7835 11.5987L10.25 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 8.61675H9.68L9.5 8.0625L9.32825 8.61675H8.75L9.2135 8.97375L9.023 9.5625L9.50225 9.19425L9.97175 9.5565L9.7835 8.97375L10.25 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 5.99175H9.68L9.5 5.4375L9.32825 5.99175H8.75L9.2135 6.34875L9.023 6.9375L9.50225 6.56925L9.97175 6.9315L9.7835 6.34875L10.25 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 3.36675H9.68L9.5 2.8125L9.32825 3.36675H8.75L9.2135 3.72375L9.023 4.3125L9.50225 3.94425L9.97175 4.3065L9.7835 3.72375L10.25 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 11.2418H6.7801L6.6001 10.6875L6.42835 11.2418H5.8501L6.3136 11.5987L6.1231 12.1875L6.60235 11.8192L7.07185 12.1815L6.8836 11.5987L7.3501 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 8.61675H6.7801L6.6001 8.0625L6.42835 8.61675H5.8501L6.3136 8.97375L6.1231 9.5625L6.60235 9.19425L7.07185 9.5565L6.8836 8.97375L7.3501 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 5.99175H6.7801L6.6001 5.4375L6.42835 5.99175H5.8501L6.3136 6.34875L6.1231 6.9375L6.60235 6.56925L7.07185 6.9315L6.8836 6.34875L7.3501 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 3.36675H6.7801L6.6001 2.8125L6.42835 3.36675H5.8501L6.3136 3.72375L6.1231 4.3125L6.60235 3.94425L7.07185 4.3065L6.8836 3.72375L7.3501 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 11.2418H3.8802L3.7002 10.6875L3.52845 11.2418H2.9502L3.4137 11.5987L3.2232 12.1875L3.70245 11.8192L4.17195 12.1815L3.9837 11.5987L4.4502 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 8.61675H3.8802L3.7002 8.0625L3.52845 8.61675H2.9502L3.4137 8.97375L3.2232 9.5625L3.70245 9.19425L4.17195 9.5565L3.9837 8.97375L4.4502 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 5.99175H3.8802L3.7002 5.4375L3.52845 5.99175H2.9502L3.4137 6.34875L3.2232 6.9375L3.70245 6.56925L4.17195 6.9315L3.9837 6.34875L4.4502 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 3.36675H3.8802L3.7002 2.8125L3.52845 3.36675H2.9502L3.4137 3.72375L3.2232 4.3125L3.70245 3.94425L4.17195 4.3065L3.9837 3.72375L4.4502 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 12.5543H16.93L16.75 12L16.5783 12.5543H16L16.4635 12.9112L16.273 13.5L16.7523 13.1317L17.2218 13.494L17.0335 12.9112L17.5 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 12.5543H14.0301L13.8501 12L13.6783 12.5543H13.1001L13.5636 12.9112L13.3731 13.5L13.8523 13.1317L14.3218 13.494L14.1336 12.9112L14.6001 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 9.92925H14.0301L13.8501 9.375L13.6783 9.92925H13.1001L13.5636 10.2862L13.3731 10.875L13.8523 10.5067L14.3218 10.869L14.1336 10.2862L14.6001 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 7.30425H14.0301L13.8501 6.75L13.6783 7.30425H13.1001L13.5636 7.66125L13.3731 8.25L13.8523 7.88175L14.3218 8.244L14.1336 7.66125L14.6001 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 4.67925H14.0301L13.8501 4.125L13.6783 4.67925H13.1001L13.5636 5.03625L13.3731 5.625L13.8523 5.25675L14.3218 5.619L14.1336 5.03625L14.6001 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 2.05425H14.0301L13.8501 1.5L13.6783 2.05425H13.1001L13.5636 2.41125L13.3731 3L13.8523 2.63175L14.3218 2.994L14.1336 2.41125L14.6001 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 12.5543H11.1302L10.9502 12L10.7784 12.5543H10.2002L10.6637 12.9112L10.4732 13.5L10.9524 13.1317L11.4219 13.494L11.2337 12.9112L11.7002 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 9.92925H11.1302L10.9502 9.375L10.7784 9.92925H10.2002L10.6637 10.2862L10.4732 10.875L10.9524 10.5067L11.4219 10.869L11.2337 10.2862L11.7002 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 7.30425H11.1302L10.9502 6.75L10.7784 7.30425H10.2002L10.6637 7.66125L10.4732 8.25L10.9524 7.88175L11.4219 8.244L11.2337 7.66125L11.7002 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 4.67925H11.1302L10.9502 4.125L10.7784 4.67925H10.2002L10.6637 5.03625L10.4732 5.625L10.9524 5.25675L11.4219 5.619L11.2337 5.03625L11.7002 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 2.05425H11.1302L10.9502 1.5L10.7784 2.05425H10.2002L10.6637 2.41125L10.4732 3L10.9524 2.63175L11.4219 2.994L11.2337 2.41125L11.7002 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 12.5543H8.23029L8.05029 12L7.87854 12.5543H7.30029L7.76379 12.9112L7.57329 13.5L8.05254 13.1317L8.52204 13.494L8.33379 12.9112L8.80029 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 9.92925H8.23029L8.05029 9.375L7.87854 9.92925H7.30029L7.76379 10.2862L7.57329 10.875L8.05254 10.5067L8.52204 10.869L8.33379 10.2862L8.80029 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 7.30425H8.23029L8.05029 6.75L7.87854 7.30425H7.30029L7.76379 7.66125L7.57329 8.25L8.05254 7.88175L8.52204 8.244L8.33379 7.66125L8.80029 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 4.67925H8.23029L8.05029 4.125L7.87854 4.67925H7.30029L7.76379 5.03625L7.57329 5.625L8.05254 5.25675L8.52204 5.619L8.33379 5.03625L8.80029 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 2.05425H8.23029L8.05029 1.5L7.87854 2.05425H7.30029L7.76379 2.41125L7.57329 3L8.05254 2.63175L8.52204 2.994L8.33379 2.41125L8.80029 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 12.5543H5.3299L5.1499 12L4.97815 12.5543H4.3999L4.8634 12.9112L4.6729 13.5L5.15215 13.1317L5.62165 13.494L5.4334 12.9112L5.8999 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 9.92925H5.3299L5.1499 9.375L4.97815 9.92925H4.3999L4.8634 10.2862L4.6729 10.875L5.15215 10.5067L5.62165 10.869L5.4334 10.2862L5.8999 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 7.30425H5.3299L5.1499 6.75L4.97815 7.30425H4.3999L4.8634 7.66125L4.6729 8.25L5.15215 7.88175L5.62165 8.244L5.4334 7.66125L5.8999 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 4.67925H5.3299L5.1499 4.125L4.97815 4.67925H4.3999L4.8634 5.03625L4.6729 5.625L5.15215 5.25675L5.62165 5.619L5.4334 5.03625L5.8999 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 2.05425H5.3299L5.1499 1.5L4.97815 2.05425H4.3999L4.8634 2.41125L4.6729 3L5.15215 2.63175L5.62165 2.994L5.4334 2.41125L5.8999 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 12.5543H2.43L2.25 12L2.07825 12.5543H1.5L1.9635 12.9112L1.773 13.5L2.25225 13.1317L2.72175 13.494L2.5335 12.9112L3 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 9.92925H2.43L2.25 9.375L2.07825 9.92925H1.5L1.9635 10.2862L1.773 10.875L2.25225 10.5067L2.72175 10.869L2.5335 10.2862L3 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 7.30425H2.43L2.25 6.75L2.07825 7.30425H1.5L1.9635 7.66125L1.773 8.25L2.25225 7.88175L2.72175 8.244L2.5335 7.66125L3 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 4.67925H2.43L2.25 4.125L2.07825 4.67925H1.5L1.9635 5.03625L1.773 5.625L2.25225 5.25675L2.72175 5.619L2.5335 5.03625L3 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 2.05425H2.43L2.25 1.5L2.07825 2.05425H1.5L1.9635 2.41125L1.773 3L2.25225 2.63175L2.72175 2.994L2.5335 2.41125L3 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 7.30425H16.93L16.75 6.75L16.5783 7.30425H16L16.4635 7.66125L16.273 8.25L16.7523 7.88175L17.2218 8.244L17.0335 7.66125L17.5 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 4.67925H16.93L16.75 4.125L16.5783 4.67925H16L16.4635 5.03625L16.273 5.625L16.7523 5.25675L17.2218 5.619L17.0335 5.03625L17.5 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 2.05425H16.93L16.75 1.5L16.5783 2.05425H16L16.4635 2.41125L16.273 3L16.7523 2.63175L17.2218 2.994L17.0335 2.41125L17.5 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M8.3617 20H1V22H5.02837L8.3617 20Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M15.0283 16H1V18H11.695L15.0283 16Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M21.695 12H18V14H18.3617L21.695 12Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M25.0283 10L28.3616 8H18V10H25.0283Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M35.0283 4H18V6H31.695L35.0283 4Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M18 1V2H38.3616L39.8921 1.08171L39.895 1.07803C39.7391 1.02738 39.5728 1 39.4001 1H18Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M2.22949 24.8461C2.46666 24.9453 2.72699 25 3.0001 25H3.61732L16.0003 17H15.3053L2.23891 24.8399L2.22949 24.8461Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M16.9717 16H17.9998V25H23.9998V16H40.9988V10H26.9717L16.9717 16Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "fr"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5 25H37V1H5V25Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H14V1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#002395",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M28 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H28V25Z",
                        fill: "#ED2939",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "ru"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 13H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V13Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "#0039A6",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V17H1V23Z",
                        fill: "#D52B1E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "de"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V9Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "#DD0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V17H1V23Z",
                        fill: "#FFCE00",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "es"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#C50A1D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 19H41V7H1V19Z",
                        fill: "#FFC300",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "18",
                        y: "12",
                        width: "1",
                        height: "4",
                        fill: "#C4C4C4",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "9",
                        y: "12",
                        width: "1",
                        height: "4",
                        fill: "#C4C4C4",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "9",
                        y: "11",
                        width: "1",
                        height: "1",
                        fill: "#C8B100",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "9",
                        y: "16",
                        width: "1",
                        height: "1",
                        fill: "#367197",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "18",
                        y: "11",
                        width: "1",
                        height: "1",
                        fill: "#C8B100",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "18",
                        y: "16",
                        width: "1",
                        height: "1",
                        fill: "#367197",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "11",
                        y: "11",
                        width: "3",
                        height: "3",
                        fill: "#AD1519",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M11 9.5L14 8.5L17 9.5L16.5 10H11.5L11 9.5Z",
                        fill: "#AD1519",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M11 14H14V17C12.3431 17 11 15.6569 11 14Z",
                        fill: "#BA640D",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "14",
                        y: "11",
                        width: "3",
                        height: "3",
                        fill: "#CCCCCC",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M14 14H17C17 15.6569 15.6569 17 14 17V14Z",
                        fill: "#AD1519",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "12",
                        y: "12",
                        width: "1",
                        height: "1",
                        fill: "#C8B100",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "13",
                        y: "13",
                        width: "2",
                        height: "2",
                        rx: "1",
                        fill: "#005BBF",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "15",
                        y: "12",
                        width: "1",
                        height: "1",
                        fill: "#ED72AA",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M11.5 10H16.5L16 11H12L11.5 10Z",
                        fill: "#C8B100",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "es-us"
                ? [
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip0_5514_23364)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M5 13H21V1H5V13Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 13H21V7H1V13Z",
                            fill: "#D52B1E",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 7H8V1H3C1.89543 1 1 1.89543 1 3V7Z",
                            fill: "#0039A6",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M4.95778 3.512H6.5L5.25733 4.512L5.73867 6L4.50178 5.084L3.26489 6L3.75289 4.44933L2.5 3.512H4.03689L4.50178 2L4.95778 3.512Z",
                            fill: "white",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip1_5514_23364)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M21 13H35V1H21V13Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M21 13H27V1H21V13Z",
                            fill: "#006847",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M32.1182 9.26513L32.1252 9.40363L32.1782 9.36913L32.1377 9.25513L32.1182 9.26513Z",
                            fill: "#FCCA3E",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M35 13H41V3C41 1.89543 40.1046 1 39 1H35V13Z",
                            fill: "#CE1126",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M28.5 6.625C28.7071 6.625 28.875 6.79289 28.875 7V7.1C28.875 8.21838 29.7816 9.125 30.9 9.125H31.1C32.2184 9.125 33.125 8.21838 33.125 7.1V7C33.125 6.79289 33.2929 6.625 33.5 6.625C33.7071 6.625 33.875 6.79289 33.875 7V7.1C33.875 8.63259 32.6326 9.875 31.1 9.875H30.9C29.3674 9.875 28.125 8.63259 28.125 7.1V7C28.125 6.79289 28.2929 6.625 28.5 6.625Z",
                            fill: "#9CA168",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M30 5.5C30 5.22386 30.2239 5 30.5 5H31.5C31.7761 5 32 5.22386 32 5.5V7.5C32 7.77614 31.7761 8 31.5 8H30.5C30.2239 8 30 7.77614 30 7.5V5.5Z",
                            fill: "#8F4620",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M31 5.5C31 5.22386 31.2239 5 31.5 5H31.691C31.8804 5 32.0535 5.107 32.1382 5.27639L32.6382 6.27639C32.8044 6.60884 32.5627 7 32.191 7H31.5C31.2239 7 31 6.77614 31 6.5V5.5Z",
                            fill: "#4D2A15",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M29.6315 7.55584C29.6697 7.35228 29.8656 7.2182 30.0692 7.25637L32.0692 7.63137C32.2727 7.66954 32.4068 7.86549 32.3686 8.06905C32.3305 8.27261 32.1345 8.40669 31.931 8.36852L29.931 7.99352C29.7274 7.95535 29.5933 7.7594 29.6315 7.55584Z",
                            fill: "#0C8489",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip2_5514_23364)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 21H21V13H1V21Z",
                            fill: "#FCD116",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 21.9995H21V19H1V21.9995Z",
                            fill: "#003893",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 23C1 24.1046 1.89543 25 3 25H21V22H1V23Z",
                            fill: "#CE1126",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip3_5514_23364)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M21 25H39C40.1046 25 41 24.1046 41 23V13H21V25Z",
                            fill: "#71AAE0",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M21 22H41V16H21V22Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: {
                            cx: "31",
                            cy: "19",
                            r: "2",
                            fill: "#FBE19F",
                          },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: {
                            cx: "31",
                            cy: "19",
                            r: "1",
                            fill: "#F6B40E",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                    _vm._v(" "),
                    _c("defs", [
                      _c("clipPath", { attrs: { id: "clip0_5514_23364" } }, [
                        _c("rect", {
                          attrs: {
                            width: "20",
                            height: "12",
                            fill: "white",
                            transform: "translate(1 1)",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("clipPath", { attrs: { id: "clip1_5514_23364" } }, [
                        _c("rect", {
                          attrs: {
                            width: "20",
                            height: "12",
                            fill: "white",
                            transform: "translate(21 1)",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("clipPath", { attrs: { id: "clip2_5514_23364" } }, [
                        _c("rect", {
                          attrs: {
                            width: "20",
                            height: "12",
                            fill: "white",
                            transform: "translate(1 13)",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("clipPath", { attrs: { id: "clip3_5514_23364" } }, [
                        _c("rect", {
                          attrs: {
                            width: "20",
                            height: "12",
                            fill: "white",
                            transform: "translate(21 13)",
                          },
                        }),
                      ]),
                    ]),
                  ]
                : this.value === "br"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#009B3A",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M6 13L21.0009 2L36 13L21.0009 24L6 13Z",
                        fill: "#FEDF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21 20.5C25.1435 20.5 28.5 17.1435 28.5 13C28.5 8.85912 25.1435 5.5 21 5.5C16.8565 5.5 13.5 8.85912 13.5 13C13.5 17.1435 16.8565 20.5 21 20.5Z",
                        fill: "#002776",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M28.0026 15.6264C26.7302 14.4537 24.4573 12.8523 21.7423 11.774C18.452 10.4673 15.1176 10.6367 13.8452 10.7117C13.9335 10.4902 14.1893 9.81609 14.3614 9.48609C16.0008 9.41374 19.1076 9.41638 22.1923 10.6402C24.7573 11.6576 26.9579 13.1276 28.3696 14.3223C28.2893 14.7361 28.1949 15.374 28.0026 15.6264Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "pt"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H16V1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#006600",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21.0358 16.6053C20.7784 16.9795 20.4735 17.3188 20.134 17.6195C19.153 18.4479 17.91 18.9739 16.4776 18.9993C14.952 19.0276 13.5057 18.1718 12.8529 17.6129C12.8277 17.5902 12.8026 17.5676 12.7783 17.5441C12.7121 17.4847 12.6478 17.4253 12.6049 17.3753C11.732 16.3885 11.0224 15.1331 11 13.4422C11.0504 12.5486 11.2453 11.788 11.5446 11.1311C12.4379 9.28467 14.3272 8 16.4972 8C19.5148 8 22 10.4779 22 13.5072C22 13.9313 21.9468 14.3442 21.8536 14.741C21.6699 15.4592 21.3668 16.101 21.0358 16.6053ZM23 13.4786C23 9.91011 20.0619 7 16.4907 7C12.9107 7 10 9.91834 10 13.5005C10 17.0799 12.9154 20 16.4907 20C20.0197 20 23 16.9828 23 13.4786Z",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12 13.4999C12 15.9852 14.0147 17.9999 16.5 17.9999C18.9853 17.9999 21 15.9852 21 13.4999V8.00988L12 7.99988V13.4999Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M19 9.99988V13.4999C19 14.8806 17.8807 15.9999 16.5 15.9999C15.1193 15.9999 14 14.8806 14 13.4999V9.99988H19ZM12.5 13.4999C12.5 15.709 14.2909 17.4999 16.5 17.4999C18.7091 17.4999 20.5 15.709 20.5 13.4999L20.5 8.49988H12.5V13.4999Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17 12.5714C17 12.6888 16.9431 12.7957 16.8531 12.8737C16.7622 12.9516 16.6364 12.9999 16.5005 12.9999C16.3616 12.9999 16.2368 12.9525 16.1469 12.8745C16.0559 12.7965 16 12.6896 16 12.5722V12.0007L16.999 11.9999L17 12.5714Z",
                        fill: "#003399",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16 10.5719C16 10.6893 16.0569 10.7963 16.1469 10.8744C16.2378 10.9524 16.3636 10.9999 16.4995 10.9999C16.6384 10.9999 16.7632 10.9524 16.8531 10.8752C16.9441 10.7971 17 10.6901 17 10.5727V10.0007L16.001 9.99988L16 10.5719Z",
                        fill: "#003399",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14 12.5714C14 12.6888 14.0569 12.7957 14.1469 12.8737C14.2378 12.9516 14.3636 12.9999 14.5005 12.9999C14.6384 12.9999 14.7632 12.9525 14.8531 12.8745C14.9441 12.7965 15 12.6896 15 12.5722V12.0007L14.002 11.9999L14 12.5714Z",
                        fill: "#003399",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M18 12.5714C18 12.8068 18.2275 12.9999 18.5005 12.9999C18.7769 12.9999 19 12.8063 19 12.5722V12.0007L18.002 11.9999L18 12.5714Z",
                        fill: "#003399",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16 14.5719C16 14.6893 16.0569 14.7963 16.1469 14.8744C16.2378 14.9524 16.3636 14.9999 16.4995 14.9999C16.6384 14.9999 16.7632 14.9524 16.8531 14.8744C16.9441 14.7971 17 14.6901 17 14.5727V14.0007L16.001 13.9999L16 14.5719Z",
                        fill: "#003399",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 17 8.99988)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 20 8.99988)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 20 11.9999)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 19.5 14.9999)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 14 8.99988)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 14 11.9999)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 14.5 14.9999)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "zh-Hans"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#FE5C55",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12.9634 11.2147H14.4562V22.1517H12.9634V11.2147ZM27.0288 22.0723H25.0945L24.7371 20.7435L26.7134 20.7844C27.239 20.7844 27.5123 20.4777 27.5123 19.8849V10.3585H19.3549V9.00925H29.0051V20.2938C29.0051 21.4794 28.3323 22.0723 27.0288 22.0723ZM17.1684 12.177H24.7582V19.884H17.1684V12.177ZM23.3495 18.6369V16.5927H18.619V18.6369H23.3495ZM18.619 15.4068H23.3495V13.4034H18.619V15.4068ZM15.0869 8.16924C16.2012 9.10962 17.0632 9.92733 17.6519 10.6428L16.5376 11.3992C15.9069 10.6428 15.0449 9.78423 13.9726 8.84386L15.0869 8.16924ZM14.6033 6.14632C14.0567 7.04581 13.468 7.88397 12.7952 8.64036L11.5127 7.84309C12.7742 6.47341 13.6992 4.96063 14.2879 3.3252L15.7596 3.63184C15.5914 4.06114 15.4232 4.47 15.2551 4.85842H20.8055V6.14632H17.6518C18.1775 6.86182 18.5979 7.53644 18.8923 8.17017L17.5467 8.6608C17.1262 7.78176 16.6216 6.9436 16.054 6.14632H14.6033ZM23.5387 6.14641C23.1182 6.92324 22.6557 7.63875 22.1301 8.29292L20.8476 7.49565C21.8988 6.22818 22.6557 4.85851 23.1182 3.34573L24.5689 3.65237C24.4427 4.06123 24.2956 4.47009 24.1274 4.85851H30.2665V6.14641H26.7765C27.26 6.80059 27.6595 7.43432 27.9749 8.00672L26.6293 8.49735C26.2088 7.67963 25.7252 6.9028 25.1576 6.14641H23.5387Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "zh-Hant"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#43D281",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6115 6.18669C14.3321 6.52387 14.0326 6.84121 13.7331 7.15856H20.5409C20.5409 7.97175 20.5209 8.7056 20.481 9.37996H21.6988V10.332H20.4011C20.3413 10.8675 20.2614 11.3633 20.1815 11.7997H21.0999V12.5931H20.0019C19.9619 12.7121 19.942 12.8311 19.902 12.9501L20.461 13.3467C19.2832 13.9616 18.0454 14.4773 16.7677 14.9136L21.5591 14.7549C22.3976 14.3384 23.236 13.9021 24.0745 13.4261L25.1127 14.1004C22.5972 15.5285 19.8821 16.6392 16.9673 17.4127C19.922 17.3135 22.8767 17.1549 25.8114 16.9565C25.3123 16.5598 24.7733 16.183 24.2143 15.7863L25.2325 15.1516C27.0891 16.3417 28.5066 17.3929 29.5048 18.3052L28.3668 19.0986C27.9276 18.6622 27.4485 18.2457 26.9094 17.8094C25.0727 17.9085 23.3359 18.0077 21.6988 18.087V20.725C21.6988 21.5977 21.1797 22.0538 20.1815 22.0538H18.2051L17.9456 20.9035C18.5844 20.9431 19.1833 20.9828 19.7623 20.9828C20.1416 20.9828 20.3413 20.7845 20.3413 20.4076V18.1465C17.9256 18.2656 15.7096 18.3449 13.6732 18.3846L13.3738 17.1945C13.7531 17.2144 14.1324 17.2342 14.5317 17.2342C16.2486 16.8772 18.0054 16.302 19.8222 15.5483L14.6515 15.707L14.4319 14.6756C14.9509 14.6756 15.3303 14.6161 15.5499 14.5368C16.5281 14.1798 17.5463 13.7434 18.6243 13.1881C18.7042 12.9699 18.7641 12.7716 18.824 12.5931H12.8946C13.0344 11.8394 13.1542 11.0857 13.274 10.332H11.8765V9.37996H13.4137C13.4936 8.66593 13.5734 7.97175 13.6333 7.25773L12.6151 8.15025L11.8765 7.25773C13.0344 6.38503 14.0126 5.23467 14.7713 3.80662L15.9691 4.0843C15.7695 4.46114 15.5499 4.81815 15.3502 5.15533H21.4193V6.18669H14.6115ZM14.4519 10.2133C14.372 10.7488 14.2722 11.2844 14.1724 11.8H19.0236C19.1235 11.2844 19.2033 10.7687 19.2632 10.2133H14.4519ZM19.3231 9.53835C19.363 9.02267 19.403 8.48715 19.4229 7.9318H14.7314L14.5517 9.53835H19.3231ZM23.6953 6.86005C23.9947 8.01041 24.6336 9.04178 25.6118 9.91447C26.3904 9.06161 26.9494 8.05008 27.2688 6.86005H23.6953ZM24.7534 10.7085C23.9149 9.85562 23.3159 8.90359 22.9366 7.87223C22.5573 8.36808 22.178 8.82426 21.7787 9.22093L21.0201 8.30857C22.1381 7.15821 23.0764 5.67066 23.7951 3.80627L25.0329 4.08395C24.7933 4.65913 24.5537 5.19465 24.2942 5.71033H29.6645V6.8607H28.4667C28.0874 8.38791 27.4485 9.65728 26.5701 10.6688C27.5284 11.3233 28.7262 11.8985 30.1237 12.3745L29.4649 13.5051C27.9476 12.9497 26.6899 12.2754 25.6917 11.5217C24.6935 12.3547 23.4557 12.9497 21.9783 13.3266L21.2996 12.2754C22.6971 11.9382 23.835 11.4225 24.7534 10.7085ZM16.0889 8.10994C16.8476 8.32811 17.5263 8.60579 18.1452 8.94296L17.7859 9.49831C17.1071 9.1413 16.4084 8.86363 15.7096 8.66529L16.0889 8.10994ZM15.7695 10.3513C16.588 10.5695 17.3267 10.8273 17.9855 11.1447L17.6062 11.7199C16.8875 11.3629 16.1488 11.105 15.4101 10.9067L15.7695 10.3513ZM24.0945 18.8001C26.0909 19.3158 27.9076 19.9306 29.5447 20.6645L28.826 21.795C27.0691 20.962 25.2524 20.3273 23.3758 19.8513L24.0945 18.8001ZM17.3267 18.8598L18.0853 19.7325C16.6479 20.5655 14.8511 21.2597 12.695 21.8151L12.156 20.7044C14.2323 20.2283 15.9691 19.6135 17.3267 18.8598Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "ee"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V6H1V23Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V9Z",
                        fill: "#0072CE",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "jp"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M15 13C15 9.68523 17.6862 7 21 7C24.3138 7 27 9.68523 27 13C27 16.3148 24.3138 19 21 19C17.6862 19 15 16.3148 15 13Z",
                        fill: "#BC002D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "hi" || this.value === "in"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 20H41V6H1V20Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V9Z",
                        fill: "#FF9933",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V17H1V23Z",
                        fill: "#128807",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21 10C22.6569 10 24 11.3431 24 13C24 14.6569 22.6569 16 21 16C19.3431 16 18 14.6569 18 13C18 11.3431 19.3431 10 21 10Z",
                        fill: "#000088",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21 10.5C22.3802 10.5 23.5 11.6192 23.5 13.0004C23.5 14.3808 22.3802 15.5 21 15.5C19.6198 15.5 18.5 14.3808 18.5 13.0004C18.5 11.6192 19.6198 10.5 21 10.5Z",
                        fill: "#CCCCE7",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21 12.5C21.2761 12.5 21.5 12.7237 21.5 12.9996C21.5 13.2755 21.2761 13.5 21 13.5C20.7239 13.5 20.5 13.2755 20.5 12.9996C20.5 12.7237 20.7239 12.5 21 12.5Z",
                        fill: "#000088",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "pl"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 13H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V13Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V13H1V23Z",
                        fill: "#DC143C",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "it"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H15V1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#009246",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M15 25H27V1H15V25Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M27 25H38.999C40.1036 25 40.999 24.1046 40.999 23V3C40.999 1.89543 40.1036 1 38.999 1H27V25Z",
                        fill: "#CE2B37",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "nl"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V6H1V23Z",
                        fill: "#21468B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V9Z",
                        fill: "#AE1C28",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "ua"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 13H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V13Z",
                        fill: "#005BBB",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V13H1V23Z",
                        fill: "#FFD500",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "toefl" || this.value === "toefl-ja"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#787AB4",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6029 14.9486C14.4869 15.4297 14.4253 15.9323 14.4253 16.4491L20.7996 18.7035L27.1736 16.4491C27.1736 15.9323 27.1122 15.4297 26.9959 14.9486L26.3269 12.0487H15.2376L14.6029 14.9486Z",
                        fill: "#5B9DB0",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.59863 11.7467L20.7992 8.03296L33.9998 11.7467L20.7992 15.7742L7.59863 11.7467Z",
                        fill: "#6CD5E5",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M20.9351 7.5514C20.8466 7.52649 20.7528 7.52649 20.6643 7.5514L7.46371 11.2651C7.25004 11.3252 7.10158 11.519 7.09915 11.741C7.09672 11.9629 7.24091 12.1599 7.45321 12.2247L12.6006 13.7952V16.8409C12.4012 16.992 12.2725 17.2314 12.2725 17.501C12.2725 17.6601 12.3173 17.8088 12.3951 17.9349L12.4572 19.7199C12.4665 19.9884 12.6864 20.2016 12.9552 20.2025L13.2011 20.2033C13.4676 20.2042 13.688 19.9959 13.7021 19.7297L13.7962 17.9489C13.8794 17.8199 13.9277 17.6661 13.9277 17.501C13.9277 17.2318 13.7993 16.9929 13.6006 16.8418V14.1003L14.2345 14.2937L14.1156 14.8368C13.9912 15.3543 13.9253 15.8946 13.9253 16.4493C13.9253 16.6612 14.0588 16.8501 14.2586 16.9207L20.6329 19.1751C20.7407 19.2132 20.8584 19.2132 20.9663 19.1751L27.3403 16.9207C27.54 16.8501 27.6736 16.6612 27.6736 16.4493C27.6736 15.8938 27.6077 15.3526 27.4825 14.8339L27.3584 14.2957L34.1462 12.2247C34.3585 12.1599 34.5027 11.9629 34.5002 11.741C34.4978 11.519 34.3493 11.3252 34.1357 11.2651L20.9351 7.5514ZM26.3996 14.5882L20.9456 16.2522C20.8505 16.2812 20.7489 16.2812 20.6538 16.2522L15.1941 14.5864L15.0891 15.066C15.0086 15.3999 14.9563 15.7454 14.9355 16.0995L20.7996 18.1733L26.6634 16.0994C26.6426 15.7453 26.5906 15.3999 26.5099 15.0663L26.5087 15.0612L26.3996 14.5882ZM14.9051 13.4528L20.7997 15.2512L32.2232 11.7659L20.7997 8.55212L9.37624 11.7659L13.1348 12.9127L20.6648 10.7908C20.9306 10.7159 21.2068 10.8707 21.2817 11.1365C21.3565 11.4023 21.2018 11.6785 20.936 11.7534L14.9051 13.4528Z",
                        fill: "#1E222E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "toeic"
                ? [
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip0_5514_23355)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                            fill: "#787AB4",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M26.8646 13.0009C26.8646 16.489 24.037 19.3167 20.5488 19.3167C17.0606 19.3167 14.2329 16.489 14.2329 13.0009C14.2329 9.5128 17.0606 6.68506 20.5488 6.68506C24.037 6.68506 26.8646 9.5128 26.8646 13.0009Z",
                        fill: "#63E1E7",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.733 12.9672C13.7323 12.978 13.7319 12.989 13.7319 13C13.7319 13.011 13.7323 13.0219 13.733 13.0326C13.7501 16.7823 16.7951 19.8167 20.5488 19.8167C24.3132 19.8167 27.3646 16.7651 27.3646 13.0009C27.3646 9.26226 24.3546 6.22659 20.6255 6.18548C20.6003 6.18457 20.5749 6.18411 20.5495 6.18408H20.5475C20.521 6.18408 20.4946 6.18457 20.4683 6.18552C16.7523 6.22854 13.751 9.24531 13.733 12.9672ZM14.7542 12.5H16.899C16.9276 11.7418 17.0207 11.0151 17.1693 10.3423H15.416C15.4024 10.3423 15.3889 10.3417 15.3756 10.3407C15.0371 10.9976 14.8201 11.7272 14.7542 12.5ZM18.244 7.65965C17.3749 8.03515 16.6157 8.61652 16.0276 9.34229H17.444C17.5672 8.97272 17.709 8.6271 17.8673 8.31036C17.9814 8.08225 18.1071 7.86381 18.244 7.65965ZM22.8501 7.65811C22.9874 7.86271 23.1134 8.08167 23.2278 8.31036C23.3861 8.6271 23.5279 8.97272 23.6512 9.34229H25.0699C24.4811 8.61553 23.7206 8.03356 22.8501 7.65811ZM25.7218 10.3405C25.7078 10.3417 25.6936 10.3423 25.6793 10.3423H23.9258C24.0744 11.0151 24.1675 11.7418 24.1961 12.5H26.3433C26.2774 11.7272 26.0603 10.9974 25.7218 10.3405ZM26.3435 13.5H24.1961C24.1675 14.2584 24.0743 14.9852 23.9257 15.6582H25.6793C25.6938 15.6582 25.7082 15.6588 25.7225 15.66C26.0609 15.0029 26.2778 14.273 26.3435 13.5ZM25.071 16.6582H23.6509C23.5278 17.0275 23.3861 17.3729 23.2278 17.6895C23.1129 17.9192 22.9862 18.1391 22.8483 18.3445C23.72 17.9688 24.4816 17.3861 25.071 16.6582ZM18.2458 18.3429C18.1082 18.138 17.9819 17.9186 17.8673 17.6895C17.7091 17.3729 17.5673 17.0275 17.4442 16.6582H16.0266C16.6152 17.3851 17.3755 17.9672 18.2458 18.3429ZM15.375 15.6599C15.0366 15.0028 14.8197 14.273 14.754 13.5H16.899C16.9276 14.2584 17.0208 14.9852 17.1695 15.6582H15.416C15.4022 15.6582 15.3885 15.6588 15.375 15.6599ZM17.8998 12.5C17.9314 11.7253 18.0355 10.9972 18.196 10.3423H20.0479V12.5H17.8998ZM21.0479 12.5V10.3423H22.8991C23.0596 10.9972 23.1638 11.7253 23.1953 12.5H21.0479ZM21.0479 9.34229H22.5894C22.5101 9.13525 22.4245 8.93991 22.3333 8.75757C21.9405 7.97182 21.4876 7.50115 21.0479 7.29968V9.34229ZM18.5057 9.34229H20.0479V7.29938C19.6079 7.50067 19.1548 7.97141 18.7618 8.75757C18.6706 8.9399 18.585 9.13524 18.5057 9.34229ZM18.506 16.6582C18.5852 16.865 18.6707 17.0601 18.7618 17.2423C19.1548 18.0284 19.6079 18.4992 20.0479 18.7005V16.6582H18.506ZM20.0479 15.6582H18.1962C18.0356 15.0032 17.9314 14.2749 17.8998 13.5H20.0479V15.6582ZM21.0479 16.6582V18.7002C21.4876 18.4987 21.9405 18.028 22.3333 17.2423C22.4244 17.0601 22.5099 16.865 22.5891 16.6582H21.0479ZM22.8989 15.6582H21.0479V13.5H23.1953C23.1638 14.2749 23.0596 15.0032 22.8989 15.6582Z",
                        fill: "#1E222E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M30.9973 12.482C30.8161 12.2736 30.5003 12.2515 30.2919 12.4327L29.1684 13.4094C28.96 13.5905 28.9379 13.9063 29.1191 14.1147C29.3002 14.3232 29.6161 14.3452 29.8245 14.1641L29.9952 14.0156C29.4883 18.7847 25.4527 22.4999 20.549 22.4999C16.0919 22.4999 12.3507 19.4303 11.3263 15.2892C11.26 15.0212 10.9889 14.8576 10.7209 14.9239C10.4528 14.9902 10.2893 15.2613 10.3556 15.5294C11.4878 20.1062 15.6214 23.4999 20.549 23.4999C26.0072 23.4999 30.4924 19.3353 31.0009 14.0104L31.2192 14.2616C31.4004 14.47 31.7162 14.4921 31.9246 14.3109C32.133 14.1298 32.1551 13.8139 31.9739 13.6055L30.9973 12.482Z",
                        fill: "#1E222E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M10.0993 13.5178C10.2805 13.7262 10.5963 13.7483 10.8047 13.5671L11.9282 12.5905C12.1366 12.4093 12.1587 12.0935 11.9775 11.8851C11.7963 11.6767 11.4805 11.6546 11.2721 11.8357L11.1016 11.984C11.6086 7.21505 15.6442 3.5 20.5477 3.5C25.0047 3.5 28.7459 6.56962 29.7703 10.7106C29.8366 10.9787 30.1076 11.1422 30.3757 11.0759C30.6438 11.0096 30.8073 10.7385 30.741 10.4705C29.6088 5.89368 25.4752 2.5 20.5477 2.5C15.0895 2.5 10.6043 6.66472 10.0959 11.9896L9.87736 11.7382C9.6962 11.5298 9.38038 11.5077 9.17198 11.6889C8.96357 11.8701 8.94149 12.1859 9.12265 12.3943L10.0993 13.5178Z",
                        fill: "#1E222E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                    _vm._v(" "),
                    _c("defs", [
                      _c("clipPath", { attrs: { id: "clip0_5514_23355" } }, [
                        _c("rect", {
                          attrs: {
                            width: "40",
                            height: "24",
                            fill: "white",
                            transform: "translate(1 1)",
                          },
                        }),
                      ]),
                    ]),
                  ]
                : this.value === "pirate"
                ? [
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip0_5514_23353)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                            fill: "#292F32",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M28.7623 14.7998C28.5943 14.5558 28.4373 14.1598 28.3123 13.6328C28.2883 13.5328 27.4883 13.2748 27.4673 13.1658C27.4353 13.0028 27.9643 13.1518 27.9383 12.9688C27.8573 12.3928 28.0303 11.5548 28.0303 10.7998C28.0303 9.79976 28.0803 7.99976 26.7053 5.99976C25.8413 4.74276 23.5623 3.99976 21.2053 3.99976C18.8483 3.99976 17.0103 4.79976 15.9013 5.99976C14.4783 7.54076 14.0253 9.59976 14.0253 10.5998C14.0253 11.9468 14.1053 13.3998 14.1343 14.1998C14.1383 14.3408 14.7323 13.8838 14.7233 13.9998C14.7053 14.2038 14.4123 15.2798 14.3303 15.4008C14.1593 15.6488 13.8823 16.0378 14.0553 16.3498C14.5263 17.1998 14.6373 17.9998 14.9193 17.9998C15.3123 17.9998 16.3953 17.7308 16.8243 17.1998C17.1953 16.7408 17.7333 15.9928 17.9233 16.1998C18.2973 16.6088 18.2413 17.9118 17.8753 18.3128C17.3313 18.9068 17.3733 19.0718 17.3733 19.5998C17.3733 20.1998 18.1063 20.1998 18.1063 20.1998C18.1063 20.1998 18.2593 20.7998 18.6513 20.4008C18.9893 20.0568 18.5113 21.1618 19.0443 20.7998C19.6343 20.4008 19.4483 20.9408 19.6853 20.9408C19.8313 20.9408 20.0893 19.3738 20.2233 19.4008C21.6043 19.6668 20.9773 20.5828 21.0753 20.5828H21.5003C22.0903 20.5828 21.7983 19.9998 21.9913 19.9998C22.2373 19.9998 22.1793 20.9998 22.4193 20.9998C22.6483 20.9998 22.4703 21.0598 22.7843 20.9848C23.1703 20.8938 22.7583 19.9788 23.1043 19.8328C23.7923 19.5458 24.5043 20.2918 24.6883 20.2918C25.2393 20.2918 24.6813 19.8918 24.6813 19.8918C24.6813 19.8918 25.0743 19.9998 25.0743 19.4008C25.0743 18.8718 25.4353 18.5948 24.8913 17.9998C24.5253 17.5998 24.5633 16.8088 24.9373 16.4008C25.1273 16.1928 25.5493 16.1418 25.9193 16.5998C26.3483 17.1308 26.5093 17.1998 26.9023 17.1998C27.2003 17.1998 27.6973 15.9298 28.6693 15.5998C29.2593 15.4008 28.9113 15.0178 28.7623 14.7998Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M19.9241 13.8007C19.5441 14.5387 19.7341 14.9997 18.4841 14.9997C17.2351 14.9997 16.0161 14.6617 16.0161 13.8007C16.0161 12.9397 15.7951 11.6427 17.0441 11.6427C18.0731 11.6427 18.6661 12.4517 19.1011 12.8417C19.5361 13.2317 20.2331 13.2007 19.9241 13.8007Z",
                            fill: "#292F32",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M22.0776 13.8007C22.4576 14.5387 22.2676 14.9997 23.5176 14.9997C24.7666 14.9997 25.9856 14.6617 25.9856 13.8007C25.9856 12.9397 26.2066 11.6427 24.9576 11.6427C23.9286 11.6427 23.3356 12.4517 22.9006 12.8417C22.4656 13.2317 21.7686 13.2007 22.0776 13.8007Z",
                            fill: "#292F32",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M20.4464 15.3104C20.2494 15.7244 19.2634 17.9994 20.0514 17.9994C21.2354 17.9994 20.2994 17.1724 20.8414 17.1724C21.6294 17.1724 21.0384 17.9994 21.8264 17.9994C22.8954 17.9994 21.6294 15.7244 21.4324 15.3104C21.2354 14.8964 20.6434 14.8964 20.4464 15.3104Z",
                            fill: "#292F32",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M33.4385 9.00872C33.9395 8.51372 34.6915 9.25672 36.1965 9.00872C37.7005 8.76072 37.1915 6.62672 36.4395 6.37972C35.6875 6.13172 33.3025 8.18773 34.1245 6.60872C34.6375 5.62272 34.2455 3.96772 33.3025 3.99972C31.6545 4.05672 32.2935 5.92372 32.0425 6.66672C31.9665 6.89272 32.8675 7.13172 29.9345 8.51272L29.4385 8.72572C29.4385 8.72572 30.5085 8.84472 29.9385 9.21972C29.3685 9.59472 30.3145 9.48572 29.9345 9.82472C29.5545 10.1657 29.9385 10.7007 29.9385 10.7007C33.3165 9.23773 33.2705 9.17472 33.4385 9.00872Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M8.78639 17.5937C8.03439 17.8417 8.30439 16.1797 6.20639 16.6057C4.97539 16.8567 4.58539 18.6637 5.51239 19.1207C6.43739 19.5777 8.95139 18.5627 7.62539 19.9997C6.90939 20.7777 7.28239 22.0517 8.78639 22.5467C10.2904 23.0427 10.0394 19.8227 10.0394 19.3277C10.0394 19.2147 9.69339 19.1077 11.4764 18.2967C11.4764 18.2967 13.2924 18.8747 11.9594 17.4167C11.9594 17.4167 11.1254 17.5807 11.4764 17.0477C12.1834 15.9717 11.4764 16.2007 11.4764 16.2007C8.99539 17.3027 8.78639 17.5937 8.78639 17.5937Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M10.4241 7.05562C8.43107 5.69862 10.7531 3.81562 9.17807 3.85662C4.69507 3.97562 7.68407 6.92762 7.68407 6.92762C9.37607 7.99962 6.68807 7.41962 6.43907 7.66562C6.19007 7.91162 4.69507 10.7456 6.68807 10.0076C8.68007 9.26962 8.43107 8.53162 9.17807 8.77762C9.17807 8.77762 9.24907 8.80062 11.8761 9.96862L11.5251 9.25962C11.5251 9.25962 11.7381 8.97562 11.3591 8.60062C10.9791 8.22562 10.7361 8.24562 11.8761 8.33962C12.6841 8.40662 12.2351 7.45762 12.2351 7.45762C11.3761 7.45762 10.5201 7.12062 10.4241 7.05562Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M34.0073 16.4716C33.7973 16.3856 34.1933 16.3326 31.0633 14.9346V15.4256C31.0633 15.4256 31.4503 15.8786 30.5013 15.9416C29.5513 16.0036 31.0873 17.2366 29.9473 17.0486C30.1373 17.6116 31.1253 17.6936 31.1253 17.6936C33.8363 18.9746 32.9393 18.4726 33.0113 18.6866C33.2603 19.4246 32.5573 20.5556 33.2563 20.6386C34.2523 20.7576 36.4983 21.7576 35.5023 19.1786C35.1043 18.1506 35.5023 18.9326 36.2493 18.6866C36.9963 18.4406 38.7393 18.0666 37.6183 16.4676C36.4983 14.8676 35.5023 17.0826 34.0073 16.4716Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                            fill: "#626C91",
                            "fill-opacity": "0.5",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("defs", [
                      _c("clipPath", { attrs: { id: "clip0_5514_23353" } }, [
                        _c("rect", {
                          attrs: { width: "42", height: "26", fill: "white" },
                        }),
                      ]),
                    ]),
                  ]
                : this.value === "ar"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#1B875B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M27 18.5755C25.901 19.4696 24.6117 20.1517 23.132 20.6217C22.1803 20.8739 21.2134 21 20.231 21C18.7513 21 17.5096 20.6246 16.5058 19.8737C15.5019 19.1229 15 17.9049 15 16.2198C15 15.5205 15.1167 14.8427 15.35 14.1865C15.5833 13.5302 16.0008 12.8667 16.6025 12.1961C16.891 11.8981 17.1074 11.676 17.2517 11.5298C17.396 11.3837 17.5234 11.2791 17.6339 11.216C16.8419 10.5741 16.4459 9.94931 16.4459 9.34175C16.4152 8.63675 16.9432 7.59359 18.0299 6.21225C18.779 5.40408 19.6048 5 20.5073 5C20.9616 5 21.4175 5.12466 21.8749 5.37399C22.3323 5.62332 22.6669 5.83253 22.8787 6.00161C23.0906 6.1707 23.2686 6.35411 23.4129 6.55185C23.5572 6.7496 23.6293 6.94017 23.6293 7.12359C23.6232 7.15225 23.6078 7.16658 23.5833 7.16658C22.736 6.87999 22.0177 6.7367 21.4282 6.7367C21.1949 6.7367 20.8956 6.78685 20.5303 6.88716C20.165 6.98746 19.7859 7.16944 19.3929 7.4331C19 7.69676 18.8035 7.96328 18.8035 8.23267C18.8035 8.50206 19.0767 8.78864 19.6232 9.09242C20.1696 9.3962 20.4981 9.56815 20.6086 9.60827C20.8419 9.57962 21.7015 9.39047 23.1873 9.04084C23.6662 8.95486 24.0238 8.89038 24.2602 8.84739C24.4965 8.80441 24.8173 8.73706 25.2226 8.64535L24.3661 11.13H24.3016C24.0622 11.13 23.5096 11.2103 22.6439 11.3708C18.4812 12.2764 16.3998 13.7723 16.3998 15.8587C16.3998 16.2312 16.6239 16.6496 17.0721 17.1139C18.0668 17.7903 19.2916 18.2087 20.7467 18.3692C21.2072 18.4494 21.6247 18.501 21.9992 18.5239C22.3738 18.5468 23.0184 18.5726 23.9332 18.6013C25.2287 18.5784 26.251 18.5698 27 18.5755Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "kr" || this.value === "ko"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M27.7004 14.107C28.2255 12.0416 26.2557 10.3552 24.6172 10.3552C23.6617 10.3552 22.7421 10.8445 22.1982 11.5455C21.9147 11.9844 20.6733 13.8099 20.4 14.1249C19.8741 14.5903 19.1918 14.9318 18.4379 14.9318C16.7994 14.9318 15.1523 13.5162 15.2078 11.2723C15.2078 11.2723 15.1053 12.1363 15.0977 12.4224C15.1216 16.1511 17.976 18.9432 21.4998 18.9176C24.7068 18.8911 27.054 16.6344 27.7004 14.107Z",
                        fill: "#003478",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M15.2151 11.2768C15.7906 8.33279 18.3846 6.10938 21.4994 6.10938C25.0369 6.10938 27.9049 8.97573 27.9049 12.5115C27.9049 13.0665 27.8341 13.6027 27.7026 14.1142L27.7 14.1065C28.2251 12.0419 26.2553 10.3555 24.6168 10.3555C23.6613 10.3555 22.7417 10.8439 22.1978 11.5449C21.9144 11.9838 20.6729 13.8102 20.3996 14.1253C19.8745 14.5906 19.1915 14.9313 18.4375 14.9313C16.799 14.9313 15.1519 13.5156 15.2074 11.2717L15.2151 11.2768Z",
                        fill: "#C60C30",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.69824 8.14819L9.51622 8.73735L13.2313 3.57671L12.4142 3.00037L8.69824 8.14819Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.1113 9.14221L10.9293 9.7288L14.6444 4.57073L13.8273 3.99438L10.1113 9.14221Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.5239 10.1337L12.3419 10.7228L16.057 5.56218L15.2399 4.98499L11.5239 10.1337Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M32.8935 9.14221L32.0755 9.7288L28.3579 4.57073L29.1776 3.99438L32.8935 9.14221Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M29.3252 7.11874L28.5072 7.70789L26.9473 5.56218L27.7652 4.98499L29.3252 7.11874Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M31.4939 10.1336L30.6759 10.7227L29.0903 8.5147L29.9075 7.94092L31.4939 10.1336Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M34.3064 8.14824L33.4884 8.73739L31.9028 6.52935L32.72 5.95386L34.3064 8.14824Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M32.1379 5.144L31.3199 5.7323L29.771 3.57634L30.5881 3L32.1379 5.144Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.5859 15.0368L12.4039 14.4502L16.1318 19.6083L15.3147 20.1855L11.5859 15.0368Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.1865 16.0303L11.0045 15.4412L12.5875 17.6492L11.7696 18.2255L10.1865 16.0303Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12.3521 19.0325L13.17 18.4459L14.7198 20.6027L13.9018 21.1799L12.3521 19.0325Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.78662 17.0372L9.6046 16.4489L13.3197 21.6078L12.5026 22.1858L8.78662 17.0372Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M32.9168 16.0303L32.0988 15.4412L30.5132 17.6492L31.3337 18.2255L32.9168 16.0303Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M30.7515 19.0325L29.9335 18.4459L28.3838 20.6027L29.2018 21.1799L30.7515 19.0325Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M31.5171 15.0368L30.6991 14.4502L29.1152 16.6557L29.9341 17.232L31.5171 15.0368Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M29.3485 18.0407L28.5331 17.4524L26.9834 19.6083L27.8014 20.1855L29.3485 18.0407Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M34.3167 17.0372L33.4987 16.4489L31.9131 18.6543L32.7336 19.2298L34.3167 17.0372Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M32.151 20.0398L31.3331 19.4507L29.7842 21.6075L30.6013 22.1864L32.151 20.0398Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "tr"
                ? [
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip0_5514_23345)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                            fill: "#E30A17",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M17.0955 17.7C14.2345 17.7 11.9155 15.371 11.9155 12.5C11.9155 9.629 14.2345 7.3 17.0955 7.3C18.6345 7.3 20.0115 7.977 20.9605 9.047C19.8155 7.217 17.7875 6 15.4745 6C11.9005 6 8.99951 8.909 8.99951 12.5C8.99951 16.091 11.9005 19 15.4745 19C17.7875 19 19.8155 17.783 20.9605 15.953C20.0115 17.022 18.6345 17.7 17.0955 17.7Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M25.2955 12.4998L26.7515 10.5168L24.3955 11.2738L22.9395 9.28979V11.7428L20.5845 12.4998L22.9395 13.2568V15.7098L24.3955 13.7258L26.7515 14.4828L25.2955 12.4998Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                            fill: "#626C91",
                            "fill-opacity": "0.5",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("defs", [
                      _c("clipPath", { attrs: { id: "clip0_5514_23345" } }, [
                        _c("rect", {
                          attrs: { width: "42", height: "26", fill: "white" },
                        }),
                      ]),
                    ]),
                  ]
                : this.value === "th"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 5H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V5Z",
                        fill: "#ED1C24",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V5H1V9Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 21H41V17H1V21Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V21H1V23Z",
                        fill: "#ED1C24",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "#241D4F",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "az"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 25H41V17H1V25Z",
                        fill: "#509E2F",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V1H1V9Z",
                        fill: "#00B5E2",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "#EF3340",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21.3222 10.0266C20.8164 9.73336 20.2283 9.56799 19.6028 9.56799C17.6998 9.56799 16.1587 11.1093 16.1587 13.0133C16.1587 14.9172 17.6998 16.4613 19.6028 16.4613C20.2283 16.4613 20.8164 16.2934 21.3222 16.0026C21.0986 16.0533 20.907 16.0746 20.6675 16.0746C18.98 16.0746 17.6119 14.7038 17.6119 13.0133C17.6119 11.3254 18.98 9.95463 20.6675 9.95463C20.9016 9.95463 21.1039 9.97863 21.3222 10.0266",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M22.3897 11.1707L22.0037 11.9441L21.1867 11.6934L21.4955 12.5306L20.689 12.872L21.4955 13.2427L21.1655 14.0747L21.9984 13.7707L22.3897 14.5732L22.7331 13.7921L23.5688 14.0987L23.284 13.2639L24.0905 12.872L23.284 12.5066L23.5928 11.6454L22.7331 12.0028L22.3897 11.1707Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "cz"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 13H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V13Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V13H1V23Z",
                        fill: "#D7141A",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M18.1221 13L1.69434 24.5127C1.26982 24.1459 1 23.605 1 23V3C1 2.39475 1.26954 1.85308 1.69434 1.48633L18.1221 13Z",
                        fill: "#11457E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "sk"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V9Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "#0B4EA2",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V17H1V23Z",
                        fill: "#EE1C25",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12.8462 19.3999C10.7496 18.9066 9.46175 17.7199 8.69272 16.2533C6.7957 12.6426 8.0595 7.34122 8.19253 6.59985H17.4998C17.6329 7.34122 18.8968 12.6426 16.9997 16.2533C16.2306 17.7199 14.943 18.9066 12.8462 19.3999Z",
                        stroke: "white",
                        "stroke-width": "0.799171",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.4999 6.56091C17.6329 7.30521 18.8967 12.6279 16.9997 16.2533H8.69279C6.79562 12.6279 8.05957 7.30521 8.19259 6.56091H17.4999Z",
                        fill: "#EE1C25",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.3573 14.8959V12.2872H14.4509C14.8952 12.2872 15.547 12.4325 15.8238 12.5995V11.0676C15.547 11.2346 14.8952 11.3772 14.4509 11.3772H13.3573V9.84549H14.1024C14.544 9.84549 14.9645 9.9908 15.2438 10.1578V8.62588C14.9645 8.79285 14.544 8.93817 14.1024 8.93817H13.3573V8.1709C13.3573 7.71593 13.4983 7.28524 13.6607 6.99988H12.0322C12.1947 7.28524 12.3356 7.71593 12.3356 8.1709V8.93817H11.5906C11.1489 8.93817 10.7285 8.79285 10.4491 8.62588V10.1578C10.7285 9.9908 11.1489 9.84549 11.5906 9.84549H12.3356V11.3772H11.242C10.7977 11.3772 10.1485 11.2346 9.86914 11.0676V12.5995C10.1485 12.4325 10.7977 12.2872 11.242 12.2872H12.3356V14.8959H13.3573Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12.8463 19.4C14.9431 18.9067 16.2308 17.72 16.9998 16.2533C16.6859 15.7253 15.5231 14.968 14.4987 15.8213C14.4508 15.3946 13.6606 14.4933 12.8463 14.4933C12.0322 14.4933 11.242 15.3946 11.194 15.8213C10.1696 14.968 9.00692 15.7253 8.69287 16.2533C9.4619 17.72 10.7497 18.9067 12.8463 19.4",
                        fill: "#0B4EA2",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "hr"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#171796",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V17Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V9Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21 19.5C17.975 19.5 15.5 17.341 15.5 14.702V9H26.5V14.702C26.5 17.341 24.025 19.5 21 19.5Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21 19V19C23.75 19 26 16.95 26 14.444V9H16V14.444C16 16.95 18.25 19 21 19",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16 11H18V9H16V11Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M18 13H19.99V11H18V13Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16 14.4629C16 14.6449 16.012 14.8239 16.035 14.9999H18V12.9999H16V14.4629Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M20 15H22V13H20V15Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M22 17H24V15H22V17Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M24 18.1855C24.446 17.8555 24.835 17.4545 25.149 16.9995H24V18.1855Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M18 17H20V15H18V17Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.8486 17C17.1626 17.455 17.5526 17.856 17.9996 18.187V17H16.8486Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21.3485 18.9902C21.5695 18.9762 21.7865 18.9492 21.9995 18.9102V17.0002H19.9995V18.9102C20.2115 18.9492 20.4295 18.9762 20.6495 18.9902C20.8825 19.0042 21.1155 19.0032 21.3485 18.9902Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M25.9645 15C25.9875 14.823 26.0005 14.644 26.0005 14.461V13H24.0005V15H25.9645Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M22 13H24V11H22V13Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M20 11H22V9H20V11Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M24 11H26V9H24V11Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M26.112 8.91307L27.353 6.14007L26.408 4.63407L24.841 5.20607L23.741 3.96707L22.293 4.78507L21 3.74207L19.708 4.78507L18.259 3.96707L17.159 5.20607L15.593 4.63407L14.647 6.14007L15.886 8.91407C17.448 8.21707 19.18 7.82807 21.001 7.82807C22.82 7.82807 24.551 8.21707 26.112 8.91307Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.194 5.32816L17.192 5.33116L15.638 4.76416L14.769 6.14716L15.102 6.89316L15.945 8.78216C16.575 8.50816 17.232 8.28216 17.91 8.11116L17.194 5.32816Z",
                        fill: "#0093DD",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.104 6.69629C17.16 6.80029 17.191 6.91929 17.191 7.04429C17.191 7.45629 16.85 7.79329 16.432 7.79329C16.063 7.79329 15.755 7.53129 15.687 7.18729C15.818 7.41629 16.067 7.57029 16.351 7.57029C16.771 7.57029 17.114 7.23229 17.114 6.81829C17.114 6.77629 17.111 6.73629 17.104 6.69629",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.562 6.12206L16.353 5.94206L16.406 5.67306L16.408 5.66106L16.396 5.66506L16.133 5.75406L15.924 5.57406L15.915 5.56506L15.912 5.57806L15.858 5.84706L15.596 5.93506L15.583 5.93906L15.593 5.94806L15.802 6.12806L15.75 6.39606L15.747 6.40906L15.759 6.40506L16.021 6.31606L16.231 6.49606L16.241 6.50506L16.243 6.49206L16.297 6.22406L16.56 6.13506L16.572 6.13006L16.562 6.12206Z",
                        fill: "#F7DB17",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M19.7218 4.91207L19.7188 4.91407L18.2818 4.10107L17.1938 5.32807L17.9098 8.11107C18.5748 7.94407 19.2608 7.83107 19.9618 7.77307L19.7218 4.91207Z",
                        fill: "#171796",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.7323 7.42084C18.4353 7.24384 19.1603 7.12384 19.9023 7.06384L19.8413 6.33984C19.0583 6.40384 18.2933 6.53084 17.5513 6.71684L17.7323 7.42084Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.3723 6.02253C18.1533 5.82653 18.9573 5.69253 19.7813 5.62553L19.7223 4.91553C18.8573 4.98553 18.0133 5.12653 17.1943 5.33153L17.3723 6.02253Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M22.2847 4.91213L22.2817 4.91413L20.9997 3.88013L19.7217 4.91213L19.9617 7.77313C20.3047 7.74613 20.6507 7.73113 20.9997 7.73113C21.3507 7.73113 21.6987 7.74613 22.0427 7.77413L22.2847 4.91213Z",
                        fill: "#0093DD",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21.4683 6.7451C21.4713 6.7361 21.4693 6.7321 21.4583 6.7311C21.4273 6.7301 21.3943 6.7281 21.3633 6.7271C21.4223 6.6641 21.4443 6.6001 21.4443 6.5291C21.4443 6.5151 21.4393 6.5101 21.4313 6.5181C21.4223 6.5301 21.4073 6.5371 21.3853 6.5381C21.3553 6.5401 21.3263 6.5411 21.2973 6.5551L21.2923 6.5401C21.2983 6.5221 21.3063 6.5051 21.3133 6.4871C21.3243 6.4801 21.3263 6.4721 21.3243 6.4611C21.3613 6.4031 21.3943 6.3461 21.4303 6.2881C21.4373 6.2771 21.4243 6.2661 21.4063 6.2781C21.3993 6.2831 21.3923 6.2861 21.3843 6.2921C21.3683 6.3031 21.3493 6.3091 21.3253 6.3111C21.2913 6.3181 21.2693 6.3331 21.2673 6.3641C21.2283 6.3411 21.1913 6.3541 21.1583 6.4041C21.1563 6.3731 21.1523 6.3441 21.1173 6.3481C21.1273 6.3251 21.1193 6.3081 21.0933 6.3011C21.0683 6.2671 21.0313 6.2381 21.0073 6.2051C21.0023 6.2001 21.0003 6.1991 20.9973 6.1991C20.9953 6.1991 20.9913 6.2001 20.9883 6.2051C20.9633 6.2381 20.9403 6.2671 20.9143 6.3011C20.9013 6.3051 20.9063 6.3161 20.9033 6.3251H20.9023C20.9023 6.3261 20.9023 6.3261 20.9023 6.3261C20.9003 6.3341 20.8873 6.3371 20.8923 6.3471C20.8573 6.3441 20.8533 6.3731 20.8513 6.4041C20.8183 6.3541 20.7813 6.3401 20.7423 6.3631C20.7403 6.3331 20.7173 6.3181 20.6833 6.3111C20.6583 6.3101 20.6403 6.3031 20.6243 6.2921C20.6163 6.2871 20.6093 6.2841 20.6013 6.2781C20.5843 6.2661 20.5713 6.2771 20.5783 6.2881C20.6143 6.3461 20.6503 6.4031 20.6863 6.4611C20.6843 6.4721 20.6873 6.4801 20.6973 6.4881L20.7173 6.5411L20.7123 6.5561C20.6823 6.5421 20.6533 6.5401 20.6233 6.5381C20.6003 6.5371 20.5843 6.5311 20.5743 6.5191C20.5673 6.5121 20.5623 6.5161 20.5623 6.5301C20.5613 6.6011 20.5843 6.6651 20.6423 6.7281C20.6123 6.7291 20.5803 6.7301 20.5493 6.7311C20.5383 6.7321 20.5363 6.7361 20.5393 6.7451C20.5563 6.7861 20.5853 6.8221 20.6503 6.8471C20.6223 6.8621 20.6063 6.8851 20.6023 6.9161C20.6013 6.9451 20.5923 6.9671 20.5733 6.9761C20.5653 6.9801 20.5623 6.9851 20.5703 6.9901C20.6043 7.0151 20.6463 7.0161 20.6913 7.0051C20.6703 7.0411 20.6603 7.0791 20.6643 7.1181C20.6923 7.1261 20.7193 7.1201 20.7473 7.1111C20.7433 7.1191 20.7403 7.1351 20.7393 7.1521C20.7393 7.1681 20.7343 7.1821 20.7253 7.1981C20.7213 7.2021 20.7173 7.2091 20.7263 7.2111C20.7713 7.2241 20.8133 7.2191 20.8493 7.2051C20.8493 7.2371 20.8493 7.2691 20.8603 7.3021C20.8623 7.3091 20.8693 7.3151 20.8763 7.3051C20.8973 7.2761 20.9203 7.2531 20.9473 7.2361C20.9513 7.2481 20.9573 7.2591 20.9683 7.2651C20.9813 7.2721 20.9883 7.2871 20.9893 7.3101C20.9893 7.3141 20.9893 7.3181 20.9943 7.3221C21.0143 7.3231 21.0633 7.2721 21.0733 7.2431C21.1013 7.2601 21.1113 7.2761 21.1323 7.3051C21.1393 7.3141 21.1453 7.3081 21.1493 7.3011C21.1573 7.2681 21.1583 7.2371 21.1583 7.2051C21.1943 7.2181 21.2363 7.2241 21.2813 7.2111C21.2913 7.2091 21.2863 7.2021 21.2823 7.1971C21.2743 7.1821 21.2683 7.1641 21.2673 7.1491C21.2653 7.1321 21.2653 7.1191 21.2613 7.1111C21.2883 7.1201 21.3153 7.1261 21.3433 7.1181C21.3473 7.0791 21.3363 7.0411 21.3153 7.0051C21.3423 7.0121 21.3643 7.0011 21.3883 6.9961C21.3893 6.9961 21.3903 6.9971 21.3903 6.9961H21.3893C21.4063 6.9931 21.4243 7.0001 21.4373 6.9901C21.4453 6.9851 21.4423 6.9801 21.4343 6.9761C21.4163 6.9671 21.4073 6.9451 21.4063 6.9161C21.4023 6.8851 21.3853 6.8611 21.3583 6.8471C21.4233 6.8221 21.4513 6.7851 21.4683 6.7451",
                        fill: "#F7DB17",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M20.6069 6.00591C20.6139 5.97391 20.6129 5.94291 20.6119 5.90991C20.6489 5.92191 20.6899 5.92491 20.7349 5.91091C20.7449 5.90791 20.7399 5.90191 20.7349 5.89791C20.7269 5.88291 20.7199 5.86491 20.7179 5.84991C20.7159 5.83191 20.7149 5.81991 20.7109 5.81291C20.7389 5.81991 20.7659 5.82391 20.7939 5.81691C20.7959 5.77691 20.7839 5.73891 20.7609 5.70391C20.7879 5.70991 20.8099 5.69791 20.8349 5.69291H20.8359H20.8349C20.8509 5.68891 20.8699 5.69491 20.8829 5.68491C20.8899 5.67891 20.8869 5.67491 20.8789 5.67091C20.8599 5.66191 20.8509 5.64191 20.8479 5.61091C20.8429 5.58091 20.8259 5.55891 20.7969 5.54491C20.8609 5.51791 20.8889 5.47991 20.9039 5.43891C20.9069 5.42991 20.9039 5.42591 20.8939 5.42591C20.8629 5.42491 20.8289 5.42491 20.7979 5.42591C20.8549 5.35991 20.8749 5.29491 20.8719 5.22391C20.8709 5.20991 20.8659 5.20491 20.8589 5.21391C20.8499 5.22591 20.8359 5.23291 20.8129 5.23491C20.7829 5.23691 20.7539 5.23991 20.7249 5.25491C20.7239 5.24991 20.7219 5.24491 20.7199 5.23991C20.7259 5.22291 20.7329 5.20491 20.7389 5.18791C20.7499 5.17991 20.7519 5.16991 20.7499 5.15991C20.7829 5.10091 20.8149 5.04191 20.8479 4.98391C20.8549 4.97291 20.8409 4.96191 20.8249 4.97391C20.8169 4.98091 20.8099 4.98391 20.8019 4.98891C20.7869 4.99991 20.7689 5.00791 20.7439 5.01091C20.7109 5.01891 20.6889 5.03491 20.6889 5.06591C20.6489 5.04391 20.6119 5.05891 20.5809 5.10991C20.5779 5.07791 20.5729 5.04991 20.5379 5.05491C20.5469 5.03091 20.5389 5.01591 20.5119 5.00891C20.4859 4.97691 20.4479 4.94791 20.4219 4.91591C20.4179 4.91191 20.4149 4.90991 20.4129 4.90991V4.91091C20.4099 4.90991 20.4069 4.91191 20.4029 4.91691C20.3789 4.95091 20.3569 4.98191 20.3339 5.01591C20.3199 5.01991 20.3259 5.03091 20.3229 5.03991H20.3219C20.3219 5.04091 20.3219 5.04091 20.3219 5.04091C20.3199 5.04891 20.3079 5.05291 20.3129 5.06291C20.2779 5.06091 20.2749 5.08991 20.2739 5.12091C20.2389 5.07191 20.2019 5.05991 20.1639 5.08491C20.1609 5.05391 20.1369 5.04091 20.1029 5.03491C20.0779 5.03391 20.0589 5.02691 20.0429 5.01791C20.0349 5.01291 20.0279 5.00991 20.0199 5.00491C20.0029 4.99291 19.9889 5.00491 19.9969 5.01591C20.0349 5.07091 20.0729 5.12791 20.1109 5.18391C20.1099 5.19391 20.1129 5.20391 20.1249 5.20991L20.1449 5.26291C20.1439 5.26791 20.1429 5.27291 20.1419 5.27691C20.1109 5.26491 20.0809 5.26391 20.0509 5.26391C20.0279 5.26291 20.0129 5.25791 20.0019 5.24691C19.9949 5.23891 19.9899 5.24391 19.9899 5.25791C19.9929 5.32891 20.0169 5.39191 20.0789 5.45291C20.0469 5.45491 20.0159 5.45691 19.9849 5.45891C19.9749 5.46091 19.9729 5.46491 19.9759 5.47391C19.9939 5.51391 20.0239 5.54891 20.0899 5.57091C20.0629 5.58691 20.0479 5.60991 20.0449 5.64191C20.0449 5.67191 20.0369 5.69291 20.0189 5.70291C20.0109 5.70791 20.0079 5.71191 20.0159 5.71791C20.0509 5.73991 20.0929 5.73991 20.1369 5.72791C20.1169 5.76491 20.1089 5.80291 20.1149 5.84191C20.1429 5.84791 20.1699 5.84191 20.1969 5.83191C20.1929 5.83991 20.1919 5.85491 20.1919 5.87291C20.1909 5.88791 20.1879 5.90291 20.1799 5.91891C20.1749 5.92391 20.1709 5.93091 20.1809 5.93291C20.2259 5.94291 20.2679 5.93591 20.3029 5.92191C20.3049 5.95391 20.3059 5.98591 20.3169 6.01791C20.3199 6.02591 20.3269 6.02991 20.3349 6.02091C20.3539 5.99091 20.3759 5.96591 20.4019 5.94891C20.4069 5.96091 20.4139 5.97091 20.4249 5.97691C20.4379 5.98391 20.4449 5.99891 20.4469 6.02191C20.4469 6.02591 20.4469 6.02891 20.4519 6.03291C20.4719 6.03291 20.5199 5.98091 20.5279 5.95091C20.5569 5.96591 20.5679 5.98291 20.5899 6.00991C20.5979 6.01991 20.6029 6.01391 20.6069 6.00591",
                        fill: "#F7DB17",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M22.0342 5.47364C22.0372 5.46464 22.0352 5.46064 22.0252 5.45864C21.9932 5.45664 21.9602 5.45364 21.9292 5.45264C21.9902 5.39064 22.0152 5.32764 22.0182 5.25664C22.0182 5.24264 22.0132 5.23764 22.0062 5.24564C21.9952 5.25664 21.9812 5.26264 21.9582 5.26364C21.9292 5.26364 21.9002 5.26464 21.8692 5.27764C21.8682 5.27164 21.8672 5.26664 21.8662 5.26164C21.8722 5.24464 21.8812 5.22764 21.8882 5.20964C21.9002 5.20364 21.9032 5.19464 21.9012 5.18364C21.9392 5.12764 21.9742 5.07164 22.0132 5.01464C22.0212 5.00464 22.0082 4.99364 21.9912 5.00364C21.9822 5.00964 21.9752 5.01264 21.9672 5.01764C21.9512 5.02764 21.9312 5.03464 21.9082 5.03464C21.8732 5.03964 21.8502 5.05464 21.8482 5.08464C21.8092 5.06064 21.7722 5.07264 21.7372 5.12164C21.7372 5.08964 21.7342 5.06064 21.6982 5.06264C21.7092 5.04064 21.7022 5.02464 21.6762 5.01564C21.6522 4.98164 21.6172 4.95064 21.5932 4.91564C21.5892 4.91164 21.5872 4.91064 21.5842 4.91064C21.5822 4.91064 21.5782 4.91164 21.5752 4.91564C21.5482 4.94864 21.5242 4.97664 21.4972 5.00864C21.4842 5.01264 21.4892 5.02464 21.4852 5.03264C21.4852 5.03264 21.4842 5.03264 21.4842 5.03364C21.4842 5.03364 21.4842 5.03364 21.4842 5.03464C21.4812 5.04064 21.4692 5.04364 21.4732 5.05364C21.4382 5.04864 21.4332 5.07764 21.4302 5.10964C21.3992 5.05864 21.3632 5.04264 21.3232 5.06564C21.3222 5.03464 21.2992 5.01964 21.2652 5.01064C21.2422 5.00864 21.2232 5.00064 21.2082 4.98964C21.2002 4.98364 21.1932 4.98064 21.1852 4.97464C21.1692 4.96164 21.1552 4.97264 21.1622 4.98364C21.1962 5.04164 21.2292 5.10164 21.2632 5.16064C21.2612 5.17064 21.2632 5.17964 21.2742 5.18764C21.2802 5.20464 21.2852 5.22364 21.2902 5.24164C21.2892 5.24564 21.2872 5.25064 21.2852 5.25564C21.2572 5.24164 21.2272 5.23864 21.1972 5.23464C21.1742 5.23264 21.1592 5.22664 21.1492 5.21464C21.1422 5.20564 21.1372 5.21064 21.1372 5.22564C21.1332 5.29564 21.1532 5.36064 21.2092 5.42564C21.1782 5.42564 21.1472 5.42464 21.1162 5.42564C21.1052 5.42564 21.1032 5.42964 21.1052 5.43864C21.1212 5.47964 21.1482 5.51764 21.2122 5.54464C21.1832 5.55864 21.1672 5.58064 21.1612 5.61164C21.1592 5.64164 21.1492 5.66164 21.1312 5.67064C21.1222 5.67464 21.1192 5.67964 21.1272 5.68464C21.1602 5.71064 21.2022 5.71364 21.2472 5.70364C21.2242 5.73964 21.2132 5.77664 21.2162 5.81664C21.2432 5.82464 21.2712 5.82064 21.2992 5.81264C21.2942 5.82064 21.2922 5.83464 21.2902 5.85364C21.2882 5.86864 21.2842 5.88264 21.2742 5.89864C21.2702 5.90264 21.2652 5.90964 21.2742 5.91064C21.3192 5.92564 21.3612 5.92164 21.3982 5.91064C21.3962 5.94264 21.3952 5.97464 21.4042 6.00664C21.4062 6.01464 21.4132 6.02064 21.4212 6.01064C21.4432 5.98364 21.4662 5.95964 21.4942 5.94564C21.4982 5.95664 21.5042 5.96764 21.5142 5.97464C21.5272 5.98264 21.5332 5.99764 21.5332 6.02064C21.5332 6.02464 21.5332 6.02864 21.5372 6.03264C21.5572 6.03464 21.6082 5.98464 21.6192 5.95564C21.6472 5.97364 21.6572 5.99064 21.6762 6.01964C21.6832 6.03064 21.6892 6.02464 21.6942 6.01764C21.7032 5.98564 21.7052 5.95364 21.7062 5.92164C21.7422 5.93564 21.7842 5.94264 21.8292 5.93264C21.8392 5.92964 21.8342 5.92264 21.8302 5.91864C21.8232 5.90364 21.8172 5.88464 21.8172 5.86964C21.8162 5.85264 21.8162 5.83964 21.8122 5.83064C21.8392 5.84164 21.8672 5.84764 21.8952 5.84164C21.9002 5.80264 21.8902 5.76464 21.8712 5.72764C21.8972 5.73564 21.9202 5.72564 21.9452 5.72164H21.9462V5.72164C21.9612 5.71864 21.9802 5.72664 21.9932 5.71764C22.0012 5.71164 21.9992 5.70764 21.9912 5.70264C21.9732 5.69264 21.9652 5.67164 21.9652 5.64164C21.9622 5.61064 21.9472 5.58664 21.9192 5.57164C21.9852 5.54864 22.0152 5.51264 22.0342 5.47364",
                        fill: "#F7DB17",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M24.8125 5.33007L24.8095 5.33107L23.7185 4.10107L22.2845 4.91207L22.0425 7.77407C22.7445 7.83207 23.4305 7.94607 24.0945 8.11307L24.8125 5.33007Z",
                        fill: "#171796",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M24.1731 6.18848C24.1531 6.18848 24.1351 6.19348 24.1171 6.21148C24.0971 6.20948 24.0761 6.21348 24.0551 6.22148C24.0071 6.20148 23.9681 6.20048 23.9211 6.21948C23.8861 6.23448 23.8451 6.23848 23.8191 6.20948C23.8011 6.18848 23.7781 6.17348 23.7501 6.16748C23.7081 6.15748 23.6631 6.15948 23.6191 6.16348C23.5921 6.16548 23.5681 6.17248 23.5441 6.18248C23.5221 6.18748 23.4991 6.18648 23.4781 6.18348C23.4451 6.14848 23.4091 6.12148 23.3651 6.11648C23.3181 6.11148 23.2671 6.11148 23.2151 6.11148C23.2081 6.09848 23.1941 6.09148 23.1801 6.08548C23.1751 6.06448 23.1651 6.04548 23.1391 6.03848C23.1341 6.00448 23.1181 5.97948 23.0851 5.96748C23.0741 5.95448 23.0621 5.94648 23.0511 5.93648C23.0431 5.92948 23.0381 5.92148 23.0381 5.91248C23.0361 5.89748 23.0291 5.88548 23.0171 5.87548C23.0091 5.86848 23.0061 5.86148 23.0051 5.85348C23.0071 5.83848 23.0041 5.82548 22.9941 5.81248C22.9981 5.80448 22.9981 5.79548 22.9951 5.78848C23.0021 5.77348 23.0061 5.75848 23.0081 5.74448C23.0271 5.76748 23.0471 5.79048 23.1031 5.75348C23.1431 5.75748 23.1731 5.74148 23.1961 5.71148C23.2351 5.69148 23.2431 5.67348 23.2181 5.67048C23.1701 5.66648 23.1361 5.65948 23.1101 5.64448C23.1021 5.63448 23.0901 5.62748 23.0741 5.62548C23.1251 5.60948 23.1851 5.60848 23.2401 5.62048C23.2961 5.63148 23.3481 5.65648 23.4091 5.70048C23.4691 5.74448 23.5211 5.79248 23.5971 5.83448C23.6921 5.88348 23.7961 5.91648 23.8931 5.90948C23.9441 5.90648 23.9901 5.89748 24.0391 5.86548C24.0481 5.85948 24.0491 5.84848 24.0491 5.84248C24.0491 5.83448 24.0421 5.83348 24.0261 5.83548C23.9941 5.84048 23.9651 5.84148 23.9381 5.84148C23.8581 5.84048 23.7951 5.82048 23.7371 5.79448C23.6431 5.75148 23.5891 5.70648 23.5411 5.66048C23.5061 5.62748 23.4661 5.59548 23.4201 5.56548C23.5461 5.61048 23.6941 5.71148 23.8821 5.59748C23.9081 5.58248 23.8931 5.56848 23.8701 5.57448C23.8411 5.58248 23.8121 5.58248 23.7821 5.58048C23.7211 5.57848 23.6641 5.57148 23.6131 5.55148C23.5721 5.53548 23.5321 5.51548 23.4921 5.49348C23.4541 5.47448 23.4171 5.45648 23.3791 5.43748C23.3371 5.41348 23.2931 5.40148 23.2481 5.39848C23.1931 5.39548 23.1381 5.39548 23.0841 5.40548C23.0331 5.40948 22.9811 5.42448 22.9301 5.45148C22.8941 5.46248 22.8611 5.48348 22.8281 5.50748C22.8041 5.52148 22.7821 5.53748 22.7601 5.55348C22.7501 5.54048 22.7351 5.52948 22.7141 5.52048C22.6661 5.49148 22.6171 5.49448 22.5671 5.50548C22.5601 5.52048 22.5531 5.53548 22.5811 5.56048C22.5751 5.57348 22.5781 5.57948 22.5881 5.58448C22.6051 5.59248 22.6151 5.60648 22.6211 5.62048C22.6361 5.62148 22.6501 5.62748 22.6631 5.63648C22.6591 5.64648 22.6571 5.65748 22.6571 5.66748C22.6281 5.69248 22.5971 5.71548 22.5831 5.75148C22.5781 5.76748 22.5651 5.78248 22.5481 5.79548C22.5161 5.81848 22.5261 5.85748 22.5791 5.85448C22.5761 5.86748 22.5791 5.87848 22.5911 5.88948C22.6011 5.89648 22.6101 5.90448 22.6151 5.91348C22.6331 5.91948 22.6511 5.92148 22.6691 5.91048C22.6851 5.89948 22.7031 5.89348 22.7251 5.89248C22.7231 5.89748 22.7211 5.90548 22.7201 5.91448C22.6731 5.95448 22.6661 5.97948 22.6921 5.99548C22.6711 6.03748 22.6711 6.06348 22.7151 6.05448C22.7161 6.06248 22.7181 6.07048 22.7231 6.07848C22.7031 6.09348 22.6981 6.10948 22.7161 6.12648C22.7171 6.13348 22.7191 6.14148 22.7231 6.14948C22.6921 6.17148 22.6541 6.19448 22.6661 6.22348C22.6701 6.23848 22.6611 6.25348 22.6521 6.26848C22.6371 6.28048 22.6251 6.29248 22.6161 6.30448C22.5941 6.33448 22.6091 6.35548 22.6501 6.35648C22.6521 6.37448 22.6571 6.38948 22.6701 6.40048C22.6571 6.41648 22.6481 6.43248 22.6701 6.44948C22.6711 6.45948 22.6751 6.47148 22.6801 6.47548C22.6871 6.47948 22.6831 6.49048 22.6761 6.49748C22.6611 6.51248 22.6521 6.52748 22.6881 6.53248C22.6951 6.53248 22.6991 6.53648 22.6991 6.54348C22.6981 6.55848 22.6961 6.57348 22.7131 6.57548C22.7221 6.58048 22.7231 6.58448 22.7151 6.58948C22.6911 6.60648 22.6921 6.62348 22.7181 6.63948C22.7231 6.66848 22.7151 6.69248 22.7031 6.71348C22.6911 6.73848 22.6821 6.76348 22.6801 6.79148C22.6541 6.79548 22.6441 6.82748 22.6411 6.87348C22.6131 6.91148 22.5781 6.93848 22.5361 6.95048C22.4961 6.96048 22.4861 6.99748 22.5341 7.00048C22.5311 7.01548 22.5391 7.02948 22.5731 7.04248C22.6201 7.05548 22.6641 7.06148 22.6991 7.02648C22.7151 7.01048 22.7201 6.99048 22.7041 6.97348C22.7041 6.96548 22.7061 6.95948 22.7081 6.95548C22.7151 6.93648 22.7261 6.92948 22.7381 6.92648C22.7491 6.92348 22.7511 6.90848 22.7491 6.88448C22.7461 6.86448 22.7491 6.84248 22.7551 6.82248C22.7781 6.81248 22.8011 6.77748 22.8081 6.73148C22.8151 6.73148 22.8221 6.71548 22.8291 6.69748C22.8401 6.68348 22.8501 6.67548 22.8631 6.68348C22.8691 6.68748 22.8731 6.68648 22.8791 6.68748C22.8771 6.70248 22.8801 6.71948 22.8831 6.73548C22.9001 6.76348 22.8821 6.82048 22.8661 6.84348C22.8541 6.86248 22.8501 6.88448 22.8571 6.90948C22.8651 6.91348 22.8591 6.91648 22.8551 6.91848C22.8491 6.92248 22.8481 6.92948 22.8491 6.93648C22.8511 6.94548 22.8471 6.95448 22.8421 6.96148C22.8271 6.98748 22.8151 7.01748 22.8031 7.04348C22.7881 7.04748 22.7761 7.06248 22.7671 7.08448C22.7571 7.08648 22.7501 7.09548 22.7451 7.10848C22.7291 7.12448 22.7151 7.12948 22.6961 7.13848C22.6801 7.14748 22.6821 7.15748 22.6891 7.16848C22.6961 7.17348 22.7011 7.17848 22.7081 7.18248C22.7171 7.18748 22.7281 7.18648 22.7371 7.18348C22.7341 7.19348 22.7321 7.20448 22.7611 7.21348C22.7781 7.22048 22.7981 7.22448 22.8181 7.21448C22.8351 7.20748 22.8521 7.19648 22.8691 7.18648C22.8891 7.16748 22.8881 7.14748 22.8801 7.12648C22.8811 7.12348 22.8811 7.11848 22.8811 7.11448C22.8931 7.10048 22.9011 7.08648 22.9051 7.07448C22.9241 7.06548 22.9351 7.04948 22.9301 7.01548C22.9361 7.00648 22.9371 6.99748 22.9371 6.98848C22.9531 6.95948 22.9661 6.93048 22.9761 6.90148C22.9941 6.87448 23.0041 6.84648 23.0041 6.82048C23.0161 6.80748 23.0251 6.79348 23.0311 6.78148C23.0481 6.78048 23.0621 6.77548 23.0761 6.77048C23.0981 6.77848 23.1201 6.77148 23.1411 6.76448C23.1561 6.79248 23.1771 6.78348 23.1991 6.76448C23.2071 6.79348 23.2251 6.80548 23.2871 6.76948C23.2851 6.77948 23.2861 6.79148 23.2891 6.79948C23.2821 6.81948 23.2881 6.84148 23.2981 6.86148C23.2981 6.86748 23.2961 6.87048 23.2981 6.87648C23.2911 6.88848 23.2871 6.90048 23.2851 6.91148C23.2591 6.93448 23.2391 6.95948 23.2351 6.99048C23.2191 7.00048 23.2071 7.01148 23.1961 7.02448C23.1591 7.03848 23.1251 7.06848 23.0921 7.10348C23.0811 7.10548 23.0691 7.10948 23.0581 7.11448C23.0451 7.11148 23.0351 7.11648 23.0321 7.12748C23.0301 7.13648 23.0341 7.14548 23.0521 7.15448C23.0521 7.16848 23.0551 7.18348 23.0811 7.19448C23.1081 7.20548 23.1371 7.20948 23.1731 7.20648C23.1911 7.20548 23.2091 7.20048 23.2221 7.18348C23.2351 7.16748 23.2331 7.14848 23.2191 7.13348C23.2261 7.13148 23.2331 7.13148 23.2401 7.13248C23.2411 7.13448 23.2431 7.13648 23.2591 7.13648C23.2781 7.13648 23.2841 7.11048 23.2861 7.07848C23.2911 7.06048 23.2981 7.04548 23.3091 7.03748C23.3381 7.01148 23.3681 6.94948 23.4191 6.94348C23.4371 6.94048 23.4511 6.93248 23.4591 6.91248C23.4801 6.89848 23.5011 6.88148 23.5211 6.86148C23.5361 6.86248 23.5481 6.85548 23.5601 6.84748C23.5671 6.84948 23.5731 6.85048 23.5791 6.85048C23.5831 6.86548 23.5931 6.87648 23.6171 6.87748C23.6251 6.88948 23.6341 6.89948 23.6491 6.90748C23.6501 6.92048 23.6521 6.93548 23.6641 6.95048C23.6481 6.97648 23.6321 7.00248 23.6161 7.03048C23.5901 7.06448 23.5641 7.09048 23.5371 7.10048C23.5031 7.11348 23.4771 7.13548 23.4711 7.17448C23.4601 7.18348 23.4501 7.19348 23.4441 7.20548C23.4251 7.21048 23.4081 7.22048 23.3891 7.22048C23.3771 7.21948 23.3721 7.21848 23.3701 7.23048C23.3691 7.25448 23.3771 7.27348 23.4121 7.27048C23.3991 7.27648 23.3911 7.29148 23.4111 7.30948C23.4341 7.33148 23.4701 7.33448 23.5271 7.31948C23.5531 7.31248 23.5801 7.29248 23.6011 7.26948C23.6171 7.25148 23.6111 7.23348 23.5931 7.21448C23.6031 7.21248 23.6101 7.20748 23.6121 7.19748C23.6421 7.18548 23.6611 7.16448 23.6671 7.13148C23.7081 7.08748 23.7451 7.04448 23.7651 7.00148C23.7691 7.00548 23.7741 7.00348 23.7771 7.00048C23.8051 6.97848 23.8351 6.95948 23.8661 6.94248C23.8721 6.93948 23.8741 6.93648 23.8741 6.93348C23.8751 6.92448 23.8801 6.92348 23.8851 6.92348C23.9121 6.92248 23.9161 6.88648 23.8981 6.85748C23.8881 6.84048 23.9031 6.83848 23.9141 6.83048C23.9291 6.81748 23.9311 6.79448 23.9321 6.77248C23.9761 6.75048 23.9851 6.72048 23.9621 6.67948C23.9941 6.65848 23.9891 6.63548 23.9541 6.61548C23.9571 6.59048 23.9561 6.56648 23.9471 6.54248C23.9821 6.54148 24.0191 6.52648 23.9941 6.48948C23.9851 6.47548 23.9801 6.46948 23.9771 6.45748C23.9961 6.45448 24.0131 6.44548 24.0271 6.42748C24.0471 6.43048 24.0581 6.42148 24.0661 6.40848C24.1021 6.40848 24.1171 6.38848 24.1021 6.33948C24.1151 6.33048 24.1241 6.31448 24.1281 6.29248C24.1631 6.29548 24.1911 6.28748 24.2051 6.25648C24.2131 6.25248 24.2191 6.24248 24.2211 6.23148C24.2271 6.19248 24.2041 6.18748 24.1731 6.18848",
                        fill: "#F7DB17",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M23.7733 5.59372C23.8073 5.59572 23.8393 5.59372 23.8673 5.58972C23.8373 5.61072 23.8003 5.62472 23.7593 5.63172C23.7673 5.62472 23.7723 5.61872 23.7743 5.61272C23.7763 5.60672 23.7763 5.59972 23.7733 5.59372",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M23.6927 5.58594C23.7147 5.58894 23.7367 5.59194 23.7597 5.59294C23.7597 5.59394 23.7607 5.59394 23.7607 5.59494C23.7647 5.59994 23.7657 5.60494 23.7637 5.60894C23.7617 5.61394 23.7567 5.61994 23.7487 5.62594C23.7467 5.62694 23.7437 5.62894 23.7477 5.63294C23.7327 5.63494 23.7167 5.63594 23.7017 5.63594C23.6937 5.63594 23.6857 5.63494 23.6777 5.63494C23.6787 5.63394 23.6797 5.63294 23.6807 5.63294C23.6887 5.62394 23.6937 5.61494 23.6957 5.60694C23.6967 5.59994 23.6957 5.59294 23.6927 5.58594",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M23.0967 5.41697C23.1347 5.41197 23.1737 5.41097 23.2127 5.41197C23.2257 5.41697 23.2357 5.42497 23.2417 5.43497C23.2477 5.44497 23.2497 5.45997 23.2467 5.47897C23.2467 5.47997 23.2467 5.48297 23.2517 5.48397C23.2577 5.48497 23.2577 5.48197 23.2587 5.47897C23.2617 5.45897 23.2587 5.44197 23.2507 5.42897C23.2467 5.42297 23.2427 5.41697 23.2367 5.41197C23.2397 5.41197 23.2427 5.41297 23.2467 5.41297C23.2917 5.41497 23.3267 5.42797 23.3667 5.44697L23.3677 5.44797C23.3757 5.45697 23.3787 5.46597 23.3777 5.47597C23.3757 5.48397 23.3697 5.49497 23.3607 5.50597C23.3587 5.50797 23.3567 5.50997 23.3607 5.51397C23.3657 5.51797 23.3677 5.51597 23.3687 5.51297C23.3797 5.50097 23.3867 5.48797 23.3887 5.47697C23.3887 5.46997 23.3887 5.46397 23.3867 5.45697C23.4197 5.47397 23.4527 5.48897 23.4857 5.50597C23.4867 5.50597 23.4877 5.50697 23.4877 5.50697L23.4887 5.50897C23.4917 5.51897 23.4897 5.52597 23.4857 5.53297C23.4807 5.53997 23.4717 5.54597 23.4587 5.55097C23.4557 5.55197 23.4527 5.55297 23.4547 5.55797C23.4567 5.56297 23.4597 5.56197 23.4627 5.56097C23.4777 5.55497 23.4887 5.54797 23.4947 5.53897C23.4997 5.53097 23.5017 5.52197 23.5007 5.51397C23.5227 5.52497 23.5437 5.53697 23.5657 5.54797H23.5667C23.5707 5.55597 23.5707 5.56297 23.5677 5.56797C23.5647 5.57497 23.5567 5.58197 23.5447 5.58797C23.5427 5.58897 23.5397 5.58997 23.5427 5.59497C23.5447 5.59997 23.5477 5.59897 23.5497 5.59797C23.5647 5.59097 23.5737 5.58197 23.5777 5.57297C23.5807 5.56697 23.5817 5.56097 23.5797 5.55397C23.5877 5.55797 23.5957 5.56097 23.6037 5.56297C23.6247 5.57097 23.6507 5.57797 23.6787 5.58297C23.6847 5.59097 23.6857 5.59797 23.6847 5.60397C23.6837 5.60997 23.6797 5.61797 23.6727 5.62497C23.6707 5.62697 23.6687 5.62897 23.6727 5.63197C23.6737 5.63297 23.6747 5.63397 23.6747 5.63397C23.5907 5.62497 23.5157 5.58597 23.4377 5.55597C23.4287 5.55197 23.4187 5.54897 23.4087 5.54497C23.3807 5.53397 23.3507 5.51997 23.3227 5.50797C23.3217 5.50697 23.3197 5.50697 23.3187 5.50597C23.3167 5.50597 23.3147 5.50497 23.3127 5.50397C23.3107 5.50397 23.3097 5.50297 23.3087 5.50297V5.50297C23.2827 5.49497 23.2557 5.48797 23.2287 5.48397C23.1987 5.47997 23.1677 5.47897 23.1367 5.48297H23.1317C23.1337 5.46697 23.1317 5.45197 23.1237 5.43897C23.1177 5.43097 23.1087 5.42297 23.0967 5.41697",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M22.959 5.45304C22.998 5.43604 23.037 5.42604 23.077 5.42004C23.095 5.42704 23.107 5.43504 23.114 5.44604C23.121 5.45604 23.123 5.46804 23.12 5.48104C23.103 5.48004 23.086 5.48004 23.07 5.48204C23.052 5.48404 23.034 5.48804 23.016 5.49404C23.007 5.47504 22.995 5.46504 22.981 5.45904C22.974 5.45604 22.967 5.45404 22.959 5.45304",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M23.3826 5.665C23.3726 5.658 23.3616 5.651 23.3506 5.645C23.2986 5.617 23.2386 5.6 23.1786 5.598L23.1796 5.597C23.2006 5.575 23.2056 5.555 23.1986 5.535C23.1936 5.52 23.1796 5.507 23.1616 5.495C23.1816 5.494 23.2006 5.495 23.2216 5.498C23.2516 5.502 23.2896 5.512 23.3246 5.525C23.3336 5.544 23.3356 5.561 23.3316 5.574C23.3276 5.589 23.3176 5.602 23.2996 5.611C23.2966 5.612 23.2946 5.613 23.2976 5.618C23.2996 5.623 23.3026 5.622 23.3046 5.62C23.3256 5.609 23.3386 5.595 23.3426 5.577C23.3466 5.563 23.3446 5.549 23.3396 5.531C23.3626 5.542 23.3836 5.555 23.3996 5.568C23.4186 5.582 23.4376 5.595 23.4566 5.609C23.4566 5.633 23.4496 5.646 23.4386 5.653C23.4256 5.66 23.4086 5.661 23.3886 5.659C23.3856 5.659 23.3826 5.659 23.3826 5.664V5.665Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M23.4981 5.74994C23.4631 5.72394 23.4291 5.69494 23.3921 5.67094C23.4131 5.67294 23.4311 5.67094 23.4441 5.66294C23.4571 5.65394 23.4661 5.64094 23.4681 5.61694C23.4901 5.63394 23.5111 5.65194 23.5311 5.67094C23.5411 5.68094 23.5511 5.68894 23.5611 5.69894H23.5621C23.5641 5.70794 23.5651 5.71494 23.5641 5.72194C23.5631 5.72794 23.5611 5.73194 23.5581 5.73594C23.5541 5.73994 23.5491 5.74294 23.5421 5.74394C23.5331 5.74694 23.5201 5.74794 23.5041 5.74594C23.5011 5.74594 23.4991 5.74594 23.4981 5.74994",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M23.6193 5.82808C23.6073 5.82208 23.5953 5.81608 23.5843 5.80908C23.5573 5.79408 23.5323 5.77608 23.5073 5.75808C23.5223 5.75908 23.5353 5.75808 23.5453 5.75508C23.5543 5.75308 23.5613 5.74908 23.5663 5.74308C23.5713 5.73708 23.5743 5.73008 23.5753 5.72208C23.5763 5.71908 23.5763 5.71508 23.5753 5.71008C23.5993 5.73008 23.6243 5.74908 23.6523 5.76608C23.6663 5.77408 23.6813 5.78208 23.6953 5.79008V5.79308C23.6973 5.80408 23.6903 5.81008 23.6793 5.81508C23.6663 5.82008 23.6463 5.82208 23.6243 5.82408C23.6213 5.82408 23.6193 5.82408 23.6193 5.82808Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M23.7479 5.8789C23.7069 5.8669 23.6669 5.8529 23.6309 5.8349C23.6519 5.8329 23.6699 5.8309 23.6839 5.8259C23.6979 5.8199 23.7069 5.8109 23.7059 5.7959C23.7299 5.8089 23.7539 5.8179 23.7789 5.8269C23.7829 5.8369 23.7829 5.8449 23.7789 5.8509C23.7739 5.8579 23.7639 5.8649 23.7499 5.8709C23.7479 5.8719 23.7459 5.8729 23.7479 5.8779V5.8789Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M24.0168 5.85157C24.0198 5.85057 24.0418 5.84557 24.0308 5.85357C23.9518 5.90457 23.8508 5.90457 23.7568 5.88057C23.7708 5.87357 23.7828 5.86657 23.7888 5.85657C23.7938 5.84857 23.7948 5.84057 23.7918 5.83057C23.8228 5.84057 23.8528 5.84757 23.8848 5.85257C23.8848 5.85657 23.8838 5.86157 23.8798 5.86657C23.8748 5.87257 23.8658 5.87757 23.8518 5.88457C23.8498 5.88557 23.8478 5.88657 23.8498 5.89157C23.8518 5.89657 23.8538 5.89557 23.8568 5.89457C23.8718 5.88757 23.8828 5.88057 23.8888 5.87257C23.8938 5.86657 23.8958 5.86057 23.8958 5.85357C23.9348 5.85757 23.9748 5.85657 24.0168 5.85157",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M23.4693 7.19628C23.4633 7.20228 23.4583 7.20928 23.4533 7.21728C23.4303 7.22428 23.4103 7.23528 23.3853 7.23428C23.3853 7.25128 23.3903 7.25828 23.4073 7.25828C23.4373 7.24228 23.4443 7.23928 23.4473 7.24228C23.4503 7.24528 23.4423 7.26628 23.4173 7.28428C23.4133 7.28628 23.4133 7.28828 23.4153 7.29228C23.4373 7.32528 23.4933 7.31328 23.5233 7.30528C23.5453 7.30028 23.5843 7.27428 23.5943 7.25328C23.5983 7.24428 23.5893 7.23028 23.5803 7.22028C23.5563 7.22428 23.5483 7.21328 23.5523 7.20628C23.5263 7.19728 23.4983 7.19528 23.4693 7.19628",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M22.6086 6.92871C22.5906 6.94271 22.5716 6.95371 22.5486 6.96071C22.5406 6.96371 22.5196 6.96871 22.5176 6.97971C22.5176 6.98371 22.5316 6.99171 22.5406 6.98771C22.5656 6.96271 22.5786 6.97671 22.5496 7.00071C22.5466 7.00571 22.5486 7.01071 22.5536 7.01571C22.5806 7.03771 22.6456 7.04571 22.6746 7.02771C22.6966 7.01371 22.7086 6.99871 22.6896 6.97871C22.6896 6.97371 22.6896 6.96971 22.6906 6.96471L22.6546 6.96071L22.6316 6.94871L22.6086 6.92871Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M23.1749 7.12299C23.1729 7.12299 23.1709 7.12299 23.1689 7.12399C23.1569 7.13699 23.1889 7.13199 23.2059 7.14299C23.2139 7.14599 23.2169 7.15599 23.2139 7.16899C23.1979 7.20599 23.1109 7.19299 23.0809 7.17899C23.0679 7.17199 23.0669 7.16299 23.0679 7.15099C23.0739 7.15099 23.0799 7.15099 23.0859 7.14999C23.0969 7.14899 23.1069 7.14499 23.1169 7.14099C23.1199 7.13899 23.1229 7.13699 23.1199 7.13199C23.1159 7.12599 23.1129 7.12699 23.1109 7.12899C23.1019 7.13399 23.0929 7.13699 23.0849 7.13799C23.0749 7.13899 23.0659 7.13899 23.0569 7.13899H23.0539C23.0499 7.13599 23.0459 7.13199 23.0479 7.12899C23.0499 7.12599 23.0579 7.12899 23.0599 7.12999C23.0729 7.12299 23.0849 7.11899 23.0999 7.11699C23.1019 7.11499 23.1039 7.11199 23.1059 7.10999C23.1329 7.11299 23.1579 7.11699 23.1749 7.12299Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M22.7686 7.10059C22.7636 7.10359 22.7616 7.10859 22.7576 7.11659C22.7426 7.13159 22.7276 7.14059 22.7076 7.14959C22.6916 7.15759 22.7066 7.16359 22.7186 7.17159C22.7286 7.17859 22.7426 7.16259 22.7506 7.15059C22.7606 7.13659 22.7696 7.14059 22.7636 7.15159C22.7566 7.16259 22.7516 7.17959 22.7516 7.18959C22.7476 7.19859 22.7846 7.20559 22.7906 7.20559C22.8136 7.20659 22.8416 7.18559 22.8596 7.17459C22.8736 7.16059 22.8726 7.14659 22.8656 7.12859V7.12759C22.8556 7.12759 22.8476 7.12659 22.8386 7.12459C22.8286 7.12259 22.8176 7.11959 22.8066 7.11559C22.8056 7.11459 22.8046 7.11359 22.8056 7.11159C22.8056 7.10959 22.8066 7.10859 22.8076 7.10959L22.7686 7.10059Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M22.7963 5.59859C22.7953 5.59559 22.7973 5.59459 22.7983 5.59259C22.8113 5.57859 22.8233 5.56759 22.8363 5.55759C22.8483 5.54859 22.8613 5.54159 22.8743 5.53859C22.8883 5.52459 22.9073 5.51559 22.9313 5.50959C22.9533 5.50359 22.9793 5.50059 23.0053 5.49759C22.9973 5.48359 22.9873 5.47359 22.9763 5.46859C22.9643 5.46359 22.9503 5.46259 22.9353 5.46459C22.9033 5.47559 22.8763 5.49259 22.8493 5.51059H22.8563C22.8643 5.51059 22.8713 5.50959 22.8783 5.51259C22.8803 5.51359 22.8833 5.51459 22.8813 5.51959C22.8793 5.52559 22.8613 5.52159 22.8563 5.52159C22.8493 5.52159 22.8413 5.52159 22.8333 5.52359C22.8313 5.52359 22.8303 5.52459 22.8293 5.52359C22.8013 5.54059 22.7793 5.55859 22.7573 5.57759C22.7743 5.58259 22.7873 5.59059 22.7963 5.59859V5.59859ZM22.9253 5.62259C22.9323 5.62259 22.9383 5.62159 22.9443 5.62259C22.9563 5.62359 22.9663 5.62859 22.9783 5.63059C23.0163 5.61659 23.0473 5.60859 23.0753 5.60959C23.1073 5.60059 23.1403 5.59659 23.1733 5.59759L23.1723 5.59659C23.1683 5.59259 23.1703 5.59059 23.1723 5.58859C23.1903 5.57159 23.1943 5.55459 23.1883 5.53859C23.1823 5.52459 23.1663 5.50959 23.1443 5.49559C23.1203 5.49859 23.0973 5.49259 23.0713 5.49459C23.0553 5.49659 23.0403 5.50059 23.0253 5.50559C23.0373 5.50959 23.0483 5.51759 23.0583 5.52859C23.0693 5.54059 23.0773 5.55959 23.0813 5.58159C23.0823 5.58459 23.0823 5.58659 23.0773 5.58759C23.0713 5.58859 23.0713 5.58659 23.0703 5.58359C23.0673 5.56359 23.0593 5.54659 23.0493 5.53559C23.0383 5.52059 23.0143 5.51459 23.0063 5.51159C22.9813 5.51359 22.9563 5.51659 22.9343 5.52259C22.9183 5.52659 22.9033 5.53259 22.8923 5.54059C22.9093 5.53659 22.9263 5.53759 22.9413 5.54459C22.9553 5.55159 22.9663 5.56559 22.9743 5.58559C22.9753 5.58859 22.9763 5.59059 22.9713 5.59259C22.9653 5.59459 22.9643 5.59159 22.9633 5.58959C22.9573 5.57159 22.9473 5.56059 22.9363 5.55459C22.9123 5.54259 22.8643 5.55359 22.8443 5.56859C22.8323 5.57759 22.8203 5.58759 22.8093 5.60159C22.8073 5.60259 22.8063 5.60459 22.8043 5.60459C22.8483 5.60759 22.8923 5.60959 22.9263 5.62259H22.9253Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M26.0532 8.78118L27.2312 6.14718L26.3622 4.76318L24.8122 5.33018L24.0952 8.11318C24.7712 8.28318 25.4252 8.50818 26.0532 8.78118",
                        fill: "#0093DD",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M24.5504 6.3457C25.3274 6.5397 26.0784 6.7987 26.8004 7.1127L26.3444 8.1287C25.6804 7.8397 24.9884 7.6027 24.2734 7.4217L24.5504 6.3457Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M26.4182 7.96579L26.7222 7.28679C26.0102 6.97779 25.2692 6.72279 24.5032 6.52979L24.3242 7.22479C25.0502 7.40679 25.7542 7.64879 26.4292 7.94279L26.4182 7.96579Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M24.7217 7.05854C24.7427 7.04554 24.7637 7.04954 24.7857 7.05254C24.8037 7.04554 24.8237 7.04354 24.8457 7.04454C24.8547 7.03954 24.8657 7.03654 24.8787 7.03454C24.8847 7.02954 24.8857 7.02354 24.8797 7.01754C24.8737 7.01054 24.8707 7.00454 24.8697 6.99754C24.8357 6.97754 24.8227 6.94754 24.8087 6.91654C24.7887 6.91254 24.7797 6.90554 24.7777 6.89754L24.7487 6.89454C24.7037 6.89954 24.6917 6.88454 24.6757 6.87254C24.6617 6.86954 24.6507 6.86154 24.6427 6.84754C24.6377 6.84154 24.6327 6.83554 24.6277 6.82954C24.6157 6.81354 24.6187 6.79254 24.6387 6.79354C24.6517 6.79554 24.6637 6.79554 24.6767 6.79054C24.6907 6.78454 24.7117 6.78454 24.7277 6.78654C24.7467 6.78554 24.7587 6.77254 24.7767 6.75554V6.73454C24.7737 6.72654 24.7777 6.72254 24.7877 6.72354C24.8127 6.72454 24.8277 6.73654 24.8377 6.75154C24.8667 6.75654 24.8887 6.77054 24.9037 6.79354C24.9417 6.79454 24.9677 6.80854 24.9707 6.82254C24.9727 6.83254 24.9617 6.84454 24.9447 6.85754V6.86454C24.9547 6.87254 24.9617 6.88154 24.9657 6.89054C24.9867 6.89854 25.0077 6.91054 25.0267 6.92554C25.0807 6.91954 25.1727 6.95854 25.2977 7.03754C25.3777 7.05054 25.4557 7.07354 25.5317 7.10454C25.5467 7.10554 25.5627 7.10554 25.5787 7.10654C25.7137 7.08654 25.8447 7.10154 25.9657 7.19354C26.0117 7.19854 26.0527 7.21254 26.0917 7.22954C26.1207 7.24154 26.1517 7.24554 26.1817 7.24754C26.2307 7.25254 26.2807 7.26454 26.3297 7.28754C26.3847 7.29954 26.4367 7.31754 26.4687 7.35554C26.4917 7.38154 26.4857 7.40754 26.4567 7.41754C26.4397 7.45454 26.4047 7.45454 26.3527 7.43754C26.3167 7.44454 26.2767 7.41554 26.2407 7.38854C26.1907 7.37254 26.1447 7.34454 26.0997 7.31454C26.0757 7.29654 26.0527 7.28654 26.0287 7.28154C26.0107 7.27754 25.9947 7.27454 25.9837 7.28154C25.9787 7.28454 25.9787 7.28654 25.9837 7.28954C25.9957 7.30054 26.0057 7.31654 26.0077 7.33454C26.0107 7.35154 26.0077 7.37054 26.0087 7.39154C26.0097 7.41254 26.0227 7.42754 26.0447 7.44154C26.0597 7.45054 26.0777 7.45954 26.1027 7.46354C26.1157 7.46554 26.1187 7.47254 26.1187 7.48254C26.1257 7.51454 26.1317 7.54654 26.1437 7.57654C26.1467 7.58454 26.1537 7.58854 26.1627 7.59554C26.1967 7.61954 26.1797 7.64554 26.1487 7.65154C26.1227 7.67454 26.0997 7.69054 26.0727 7.69654C26.0507 7.70354 26.0417 7.69454 26.0347 7.68454C26.0217 7.68354 26.0147 7.67854 26.0097 7.67054C25.9827 7.65154 26.0057 7.61854 26.0687 7.63154C26.0707 7.62454 26.0757 7.62154 26.0807 7.62254C26.0767 7.60654 26.0757 7.58854 26.0817 7.57154C26.0767 7.56854 26.0717 7.56354 26.0637 7.56054C26.0407 7.55354 26.0187 7.54254 26.0017 7.52754C25.9697 7.49654 25.9187 7.47154 25.8697 7.44654C25.8297 7.44454 25.7997 7.42654 25.7677 7.41154C25.7537 7.41154 25.7397 7.41054 25.7247 7.41054C25.7127 7.40654 25.7017 7.41054 25.6947 7.41854C25.6817 7.43454 25.6677 7.43154 25.6497 7.42954C25.6297 7.42754 25.6097 7.42954 25.5897 7.42854C25.5797 7.43154 25.5707 7.43454 25.5597 7.43454C25.5367 7.43354 25.5147 7.43254 25.5007 7.44554C25.4877 7.45754 25.4757 7.45654 25.4637 7.45254C25.4537 7.44854 25.4477 7.44354 25.4437 7.43954C25.4277 7.43554 25.4177 7.43154 25.4137 7.42754C25.3877 7.41954 25.3807 7.41254 25.3817 7.40554C25.3467 7.39754 25.3637 7.37054 25.3867 7.36954C25.4127 7.36854 25.4367 7.37254 25.4637 7.37654C25.4857 7.38254 25.5127 7.37854 25.5307 7.36354C25.5417 7.35354 25.5457 7.34354 25.5597 7.33654C25.5147 7.33354 25.4817 7.32654 25.4567 7.31054C25.3907 7.26954 25.3387 7.25954 25.2967 7.29354C25.2847 7.30054 25.2767 7.30254 25.2647 7.29854C25.2547 7.29454 25.2417 7.29454 25.2317 7.29654C25.2077 7.30154 25.1837 7.29854 25.1597 7.29054C25.1257 7.29954 25.0907 7.30054 25.0557 7.29354C25.0267 7.30954 25.0047 7.31154 24.9917 7.29954C24.9777 7.29154 24.9657 7.28554 24.9537 7.27754C24.9357 7.27454 24.9277 7.26954 24.9267 7.26354C24.9027 7.26054 24.8997 7.25154 24.8997 7.24354C24.8897 7.23154 24.8937 7.22254 24.9037 7.21554C24.9217 7.20754 24.9397 7.20554 24.9607 7.21554C24.9727 7.22154 24.9817 7.22754 24.9887 7.23354C25.0027 7.23154 25.0137 7.23354 25.0247 7.23754C25.0327 7.22554 25.0537 7.22454 25.0767 7.22554C25.0887 7.21854 25.1027 7.21254 25.1207 7.21054C25.1197 7.20754 25.1197 7.20554 25.1187 7.20354C25.0957 7.19754 25.0837 7.17954 25.0717 7.16254C25.0357 7.16254 25.0097 7.14754 24.9837 7.13154C24.9627 7.13354 24.9457 7.12654 24.9287 7.11754C24.9147 7.11854 24.9007 7.11854 24.8867 7.11554C24.8577 7.12154 24.8317 7.12154 24.8067 7.11554C24.7887 7.11654 24.7747 7.11454 24.7607 7.11354C24.7437 7.13154 24.7247 7.13554 24.7047 7.12554C24.6937 7.11254 24.6777 7.10254 24.6577 7.09754C24.6427 7.09254 24.6377 7.08554 24.6347 7.07954C24.6167 7.06754 24.6197 7.05654 24.6387 7.04754C24.6517 7.04154 24.6687 7.04054 24.6937 7.05254C24.7017 7.05554 24.7117 7.05854 24.7217 7.05854Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M25.6096 7.32625C25.6086 7.32225 25.6046 7.31425 25.5906 7.32225C25.5486 7.32025 25.5016 7.32125 25.4656 7.30125C25.4286 7.27925 25.3906 7.25725 25.3506 7.25825C25.3626 7.24725 25.3776 7.23925 25.3946 7.23425C25.4186 7.22825 25.4456 7.22825 25.4766 7.23325C25.5196 7.24025 25.5576 7.24825 25.5876 7.25925C25.6156 7.26925 25.6356 7.28225 25.6446 7.29925C25.6446 7.30025 25.6466 7.30225 25.6466 7.30225C25.6576 7.30925 25.6676 7.31625 25.6756 7.32425C25.6826 7.33025 25.6876 7.33625 25.6926 7.34225C25.6786 7.34425 25.6656 7.34325 25.6516 7.34025C25.6366 7.33725 25.6226 7.33225 25.6096 7.32525V7.32625Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M26.5375 5.60249L26.5255 5.59749L26.2605 5.50749L26.2065 5.23749L26.2045 5.22449L26.1945 5.23249L25.9835 5.41449L25.7185 5.32449L25.7065 5.32049L25.7085 5.33149L25.7615 5.60349L25.5505 5.78449L25.5415 5.79249L25.5535 5.79649L25.8175 5.88749L25.8715 6.15849L25.8735 6.17049L25.8835 6.16249L26.0955 5.98149L26.3605 6.07149L26.3725 6.07549L26.3705 6.06249L26.3165 5.79149L26.5275 5.61049L26.5375 5.60249Z",
                        fill: "#F7DB17",
                      },
                    }),
                  ]
                : this.value === "ge"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M19 25H23V1H19V25Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 15H41V11H1V15Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M9.239 5.253C8.276 5.253 7.398 5.04 7 4.941V7.06C7.398 6.963 8.276 6.747 9.239 6.747C9.239 7.707 9.04 8.604 8.939 9H11.061C10.96 8.604 10.761 7.707 10.761 6.747C11.724 6.747 12.602 6.963 13 7.06V4.941C12.602 5.04 11.724 5.253 10.761 5.253C10.761 4.293 10.96 3.397 11.061 3H8.939C9.04 3.397 9.239 4.293 9.239 5.253Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M9.239 19.253C8.276 19.253 7.398 19.04 7 18.941V21.06C7.398 20.963 8.276 20.747 9.239 20.747C9.239 21.707 9.04 22.604 8.939 23H11.061C10.96 22.604 10.761 21.707 10.761 20.747C11.724 20.747 12.602 20.963 13 21.06V18.941C12.602 19.04 11.724 19.253 10.761 19.253C10.761 18.293 10.96 17.397 11.061 17H8.939C9.04 17.397 9.239 18.293 9.239 19.253Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M31.239 5.253C30.276 5.253 29.398 5.04 29 4.941V7.06C29.398 6.963 30.276 6.747 31.239 6.747C31.239 7.707 31.04 8.604 30.939 9H33.061C32.96 8.604 32.761 7.707 32.761 6.747C33.724 6.747 34.602 6.963 35 7.06V4.941C34.602 5.04 33.724 5.253 32.761 5.253C32.761 4.293 32.96 3.397 33.061 3H30.939C31.04 3.397 31.239 4.293 31.239 5.253Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M31.239 19.253C30.276 19.253 29.398 19.04 29 18.941V21.06C29.398 20.963 30.276 20.747 31.239 20.747C31.239 21.707 31.04 22.604 30.939 23H33.061C32.96 22.604 32.761 21.707 32.761 20.747C33.724 20.747 34.602 20.963 35 21.06V18.941C34.602 19.04 33.724 19.253 32.761 19.253C32.761 18.293 32.96 17.397 33.061 17H30.939C31.04 17.397 31.239 18.293 31.239 19.253Z",
                        fill: "#FF0000",
                      },
                    }),
                  ]
                : this.value === "np"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11 0V26H33.1481L20 14H34L11 0Z",
                        fill: "#003893",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12 25.037L11.9629 1.9259L30 13H17L30 25L12 25.037Z",
                        fill: "#DC143C",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.494 17L15.987 18.355L14.928 17.354L15.077 18.774L13.682 18.33L14.455 19.553L13 19.729L14.234 20.498L13 21.28L14.465 21.463L13.688 22.7L15.093 22.226L14.944 23.652L16.003 22.654L16.494 24L16.998 22.654L18.047 23.652L17.898 22.226L19.293 22.7L18.533 21.463L19.991 21.286L18.758 20.498L20 19.72L18.533 19.553L19.303 18.33L17.905 18.774L18.063 17.354L17.004 18.355L16.494 17Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M19 8.44775C18.454 9.15425 17.6481 9.6965 16.7128 9.95675L16.5115 9.8L17.0391 9.56375L16.5902 9.30875L17.1205 8.981L16.5054 8.843L16.6944 8.312L16.095 8.54525L16.0591 8.01425L15.6452 8.49125L15.465 8L15.2882 8.49875L14.863 8.01125L14.8394 8.5535L14.2391 8.32025L14.4281 8.85125L13.8139 8.99L14.3441 9.317L13.8979 9.572L14.4159 9.81575L14.2155 9.9755C13.3248 9.743 12.5548 9.26075 12 8.61575C12.4191 9.98975 13.8165 11 15.4772 11C17.2045 11 18.6491 9.908 19 8.44775",
                        fill: "white",
                      },
                    }),
                  ]
                : this.value === "unknown"
                ? [
                    _c("path", {
                      attrs: {
                        d: "M24 14.5C24.3333 13.6667 24.7252 13.7748 26 12.5C27 11.5 27.5 10.5 27.5 9C27.5 8 27.3 6.8 26.5 6",
                        stroke: "#8EA3EE",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M22.6057 20C22.6057 20.7732 21.9789 21.4 21.2057 21.4C20.4325 21.4 19.8057 20.7732 19.8057 20C19.8057 19.2268 20.4325 18.6 21.2057 18.6C21.9789 18.6 22.6057 19.2268 22.6057 20Z",
                        fill: "#2C3143",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M19.033 7.91776C18.5857 8.74417 17.9134 9.09186 17.2738 8.80982C16.6342 8.52779 16.5263 7.98417 16.6373 7.67261C17.2235 6.02723 18.9119 4.5 21.4998 4.5C24.2229 4.5 26.6054 6.08072 26.6054 9.0719C26.6054 9.91318 26.4079 10.5071 26.1257 10.9708C25.1311 12.6052 22.9484 13.1437 22.6129 15.2413C22.4955 15.9753 21.9482 16.4 21.2139 16.4C20.4486 16.4 19.9998 16 19.9663 15.0414C19.9663 12 24.3054 11.271 24.3054 8.99998C24.3054 7.17781 23.1622 6.5 21.4998 6.5C20.4658 6.5 19.4291 7.18602 19.033 7.91776Z",
                        fill: "#2C3143",
                      },
                    }),
                  ]
                : this.value === "no"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#BA0C2F",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11 1V9H1V17H11V25H19V17H41V9H19V1H11Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13 1V11H1V15H13V25H17V15H41V11H17V1H13Z",
                        fill: "#00205B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "sv"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#006AA7",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12 1V10H1V15H12V25H17V15H41V10H17V1H12Z",
                        fill: "#FECC00",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "da"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#C8102E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14 1V10H1V15H14V25H19V15H41V10H19V1H14Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "fi"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12 10V1H18V10H41V16H18V25H12V16H1V10H12Z",
                        fill: "#002F6C",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          )
        : [
            _c("span", { staticClass: "letters" }, [
              _vm._v(_vm._s(_vm.letters)),
            ]),
            _vm._v(" "),
            _vm.backupIllustrationData
              ? _c(
                  "svg",
                  {
                    staticClass: "backupIllustration",
                    attrs: {
                      width: "43",
                      height: "26",
                      viewBox: "0 0 43 26",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("circle", {
                      attrs: {
                        cx: _vm.backupIllustrationData.x,
                        cy: _vm.backupIllustrationData.y,
                        r: _vm.backupIllustrationData.r,
                        fill: _vm.leColor.hex,
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }